<template>
  <div class="ml-5">
    <br />
    <div class="d-flex">
      <div>
        <img width="24px" height="24px" style="margin-top:auto;margin:bottom:auto;"
          src="@/assets/images/Mask Group 21@2x.png" />
      </div>
      <div class="ml-3">
        <label style="font-size: 17px; color: #f89d1f">{{
          $t("personalinformation")
        }}</label>
      </div>
    </div>

    <v-row class="content">
      <v-col cols="12" md="9">
        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" class="pb-0">
            <!-- <label class="forlabel">{{$t('employeeid')}}</label> -->
            <v-text-field :disabled="disableall" v-on:keyup="keymonitor" v-model="addpersonalinfo.employeecode"
              :error-messages="error.errormessageempid" color="#F99D20" class="mt-3">
              <template v-slot:label>
                <span>
                  {{ $t("employeeid") }}<span class="red--text"> *</span></span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" xs="12" sm="12" md="4" lg="4">
            <!-- <label class="forlabel">{{$t('employeeid')}}</label> -->
            <v-text-field :disabled="disableall" v-on:keyup="keymonitor" v-model="addpersonalinfo.prefix"
              :error-messages="error.errormessageprefix" color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("Prefix") }}<span class="red--text"> *</span></span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4">
            <!-- <label  class="forlabel">{{$t('name')}}</label> -->
            <v-text-field :disabled="disableall" autocomplete="off" v-on:keyup="keymonitor"
              v-model="addpersonalinfo.firstname" :error-messages="error.errormessagename" color="#F99D20">
              <template v-slot:label>
                <span> {{ $t("Name") }}<span class="red--text"> *</span></span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4">
            <!-- <label class="forlabel">{{$t('last_name')}}*</label> -->
            <v-text-field :disabled="disableall" autocomplete="off" v-on:keyup="keymonitor"
              :error-messages="error.errormessagelastname" v-model="addpersonalinfo.lastname" color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("last_name") }}<span class="red--text"> *</span></span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" sm="6" md="4">
            <v-text-field autocomplete="off" :disabled="disableall" color="#F99D20" class="empID"
              v-on:keyup="keymonitor" v-model="addpersonalinfo.nickname" style="margin-top: 0.9rem"
              :label="$t('nickname')"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete autocomplete="off" :items="genderitems" item-text="txt" item-value="val"
              :error-messages="error.errormessagegender" :disabled="disableall" @change="change()"
              v-model="addpersonalinfo.gender" class="empID" style="margin-top: 0.9rem; font-size: 17px"
              append-icon="mdi-chevron-down" color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("gender") }}<span class="red--text"> *</span></span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete class="empID" autocomplete="off" style="margin-top: 0.9rem; font-size: 17px"
              :disabled="disableall" @change="change()" v-model="addpersonalinfo.religion"
              :error-messages="error.errormessagereligion" :items="religionitems" item-text="txt" item-value="val"
              append-icon="mdi-chevron-down" color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("religion") }}<span class="red--text"> *</span></span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" sm="6" md="4" class="pt-0">
            <!-- <v-menu
              v-model="menu6"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              fluid
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  autocomplete="off"
                  class="empID"
                  readonly
                  style="margin-top: 0.9rem; font-size: 17px"
                  :disabled="disableall"
                  append-icon="mdi-calendar-month-outline"
                  v-model="computedDateFormatted6"
                  :error-messages="error.errormessageDOB"
                  color="#F99D20"
                  persistent-hint
                  v-on="on"
                >
                  <template v-slot:label>
                    <span> {{ $t("date_of_birth") }}<span class="red--text"> *</span></span>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                @change="getAge(addpersonalinfo.DOB) || change()"
                v-model="addpersonalinfo.DOB"
                no-title
                @input="menu6 = false"
                :allowed-dates="allowedDates"
              ></v-date-picker>
              <date-picker v-bind:clearable="false" format="DD/MM/YYYY"
                :style="{ width: '100%' }" no-title readonly v-model="addpersonalinfo.DOB" @change="getAge(addpersonalinfo.DOB) || change()" :disabled-date="allowedDates" class="px-3">
              </date-picker>
            </v-menu> -->
            <!-- <div class="date-picker-container">
              <label class="date-picker-label"> {{ $t("date_of_birth") }} </label> -->
            <!-- <date-picker class="custom-vuedatepicker mt-3" :disabled="disableall" v-bind:clearable="false" @change="getAge(addpersonalinfo.DOB) || change()" :disabled-date="allowedDates"
              v-model="addpersonalinfo.DOB" :allowed-dates="allowedEndDates" no-title format="DD/MM/YYYY" :style="{ width: '100%' }"></date-picker> -->
            <!-- </div> -->
            <label class="custom-label-1" :style="{ color: error.errormessageDOB ? ' #FF4B55' : '#8a8c8e' }">
              {{ $t("date_of_birth") }}<span class="red--text"> *</span>
            </label>
            <date-picker :class="error.errormessageDOB ? 'custom-vuedatepicker-er-mg' : 'custom-vuedatepicker'"
              v-bind:clearable="false" value-type="YYYY-MM-DD" v-model="addpersonalinfo.DOB"
              @change="getAge(addpersonalinfo.DOB) || change()" :disabled-date="(date) => date > new Date()"
              :disabled="disableall" :editable="false" :error-messages="error.errormessageDOB" no-title
              format="DD/MM/YYYY" readonly :style="{ width: '100%' }">
            </date-picker>
            <span v-if="error.errormessageDOB" class="error-message">{{ error.errormessageDOB }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field autocomplete="off" color="#F99D20" disabled :class="!disableall ? 'forage' : ''"
              v-model="addpersonalinfo.age" :error-messages="error.errormessageage" v-on:keyup="keymonitor"
              class="empID" style="margin-top: 0.9rem">
              <template v-slot:label>
                <span :style="!disableall ? 'color:rgba(0, 0, 0, 0.6) !important;' : ''"> {{ $t("age") }}</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete autocomplete="off" :items="mstatusitems" item-text="txt" item-value="val"
              :error-messages="error.errormessagemartialstatus" :disabled="disableall"
              v-model="addpersonalinfo.martialstatus" @change="change()" class="empID" style="margin-top: 0.9rem"
              append-icon="mdi-chevron-down" color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("martialstatus")
                  }}<span class="red--text"> *</span></span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <!-- personal id file -->

        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="9" sm="5" md="3" style="padding-right: 0">
            <v-text-field autocomplete="off" color="#F99D20" :error-messages="error.errormessagepersonalid"
              :disabled="disablepersonalID" @keypress="onlyNumberforpersonalandtax" class="empID per"
              style="margin-top: 1.5rem" v-model="addpersonalinfo.personalID_Number" v-on:keyup="keymonitor">
              <template v-slot:label>
                <span>
                  {{ $t("personal_id") }}<span class="red--text"> </span></span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="3" sm="1" md="1" style="padding-left: 0px">
            <v-btn color="#F99D20" class="white--text text-capitalize mt-5 file-btn perfile" style="font-weight: normal"
              width="60" height="35" :disabled="disablepersonalID" @click="gopersonalid()" v-model="imgname">{{
                $t("file")
              }}</v-btn>
          </v-col>
          <!-- <v-col md="1" style="padding-left:0px">
            <v-btn
              color="#F99D20"
              class="white--text pl-5 ml-5 text-capitalize mt-5"
              width="60"
              height="35"
              @click="gopersonalid()"
              v-model="imgname"
            >File</v-btn>
          </v-col>-->
          <v-col cols="12" sm="6" md="4" class="mt-2 pt-0">
            <label class="custom-label-1" style="color: #8a8c8e">
              {{ $t("expired_date") }}
            </label>
            <date-picker class="custom-vuedatepicker pt-0 mt-0" v-bind:clearable="false" value-type="YYYY-MM-DD"
              v-model="addpersonalinfo.expired_date" :disabled="disableall"
              :error-messages="error.errormessageexpireddate" no-title format="DD/MM/YYYY" :style="{ width: '100%' }">
            </date-picker>
            <!-- <v-menu
              v-model="menu7"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              fluid
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  autocomplete="off"
                  append-icon="mdi-calendar-month-outline"
                  v-model="computedDateFormatted7"
                  :error-messages="error.errormessageexpireddate"
                  :disabled="disableall"
                  class="kanit-medium"
                  color="#F99D20"
                  persistent-hint
                  v-on="on"
                >
                  <template v-slot:label>
                    <span> {{ $t("expired_date") }}</span>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                @change="change()"
                v-model="addpersonalinfo.expired_date"
                no-title
                @input="menu7 = false"
              ></v-date-picker>
            </v-menu> -->
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field autocomplete="off" color="#F99D20" :error-messages="error.errormessagetaxpayer"
              @keypress="onlyNumberforpersonalandtax" v-on:keyup="keymonitor" v-model="addpersonalinfo.taxpayerID"
              :disabled="disableall" class="empID" style="margin-top: 1.5rem">
              <template v-slot:label>
                <span> {{ $t("taxpayerid") }}</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" sm="6" md="4">
            <v-btn color="#F99D20" style="font-weight: 5px; font-size: 16px"
              class="white--text mr-4 text-capitalize mt-5" block height="35" @click="goeducation()"
              :disabled="disableall">{{ $t("Educational_background") }}</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="8">
            <div class="d-flex mt-2 ml-3 edu">
              <v-checkbox class="custom-checkbox24" color="#F99D20" @change="change()"
                v-model="addpersonalinfo.foreignemployee" :disabled="disableall"></v-checkbox>
              <p class="mt-5" style="font-size: 17px; color: #8a8c8e">
                {{ $t("foreignemp") }}
              </p>
            </div>
          </v-col>
        </v-row>

        <!-- for show hide -->
        <v-row v-if="addpersonalinfo.foreignemployee" class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col>
            <v-row>
              <v-col cols="9" sm="3" md="3" style="padding-right: 0">
                <v-text-field autocomplete="off" color="#F99D20" class="empID"
                  style="margin-top: 1.5rem; margin-right: -10px" :label="$t('workpermit')" :disabled="disableall"
                  v-on:keyup="keymonitor" v-model="workpermitname"></v-text-field>
              </v-col>
              <v-col cols="1" sm="1" md="1" style="padding-left: 0px">
                <v-btn color="#F99D20" class="white--text mr-4 text-capitalize mt-5 file-btn" width="60" height="35"
                  :disabled="disableall" @click="goworkpermit()">{{ $t("file") }}</v-btn>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mt-2 pt-0">
                <label class="custom-label-1" style="color: #8a8c8e">
                  {{ $t("expired_date") }}
                </label>
                <date-picker class="custom-vuedatepicker pt-0 mt-0" v-bind:clearable="false" value-type="YYYY-MM-DD"
                  v-model="addpersonalinfo.workpermitexpiredate" :disabled="disableall" no-title format="DD/MM/YYYY"
                  :style="{ width: '100%' }">
                </date-picker>
                <!-- <v-menu
                  v-model="menu12"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  fluid
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      autocomplete="off"
                      append-icon="mdi-calendar-month-outline"
                      v-model="computedDateFormatted12"
                      :disabled="disableall"
                      :label="$t('expired_date')"
                      class="kanit-medium"
                      color="#F99D20"
                      persistent-hint
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="addpersonalinfo.workpermitexpiredate"
                    @change="change()"
                    no-title
                    @input="menu12 = false"
                  ></v-date-picker>
                </v-menu> -->
              </v-col>
              <v-col cols="9" sm="3" md="3" style="padding-right: 0">
                <v-text-field autocomplete="off" color="#F99D20" class="empID"
                  style="margin-top: 1.5rem; margin-right: -10px" :label="$t('otherinfo')" v-on:keyup="keymonitor"
                  v-model="otherimagename" :disabled="disableall"></v-text-field>
              </v-col>
              <v-col cols="1" sm="1" md="1" style="padding-left: 0px">
                <v-btn color="#F99D20" class="white--text mr-4 text-capitalize mt-5 file-btn" width="60" height="35"
                  :disabled="disableall" @click="goother()">{{ $t("Add") }}</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="9" sm="3" md="3" style="padding-right: 0">
                <v-text-field autocomplete="off" color="#F99D20" class="empID"
                  style="margin-top: 1.5rem; margin-right: -10px" :disabled="disableall" v-model="passport"
                  :error-messages="error.errormessagepassport" v-on:keyup="keymonitor">
                  <template v-slot:label>
                    <span>
                      {{ $t("passport")
                      }}<span class="red--text"> *</span></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="1" sm="1" md="1" style="padding-left: 0px">
                <v-btn color="#F99D20" class="white--text mr-4 text-capitalize mt-5 file-btn" width="60" height="35"
                  :disabled="disableall" @click="gopassport()" v-model="imgname">
                  {{ $t("file") }}
                  <input ref="image2" @change="onFilePicked2" accept="image/*" type="file" style="display: none" />
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mt-2 pt-0">
                <label class="custom-label-1" style="color: #8a8c8e">
                  {{ $t("expired_date") }}
                </label>
                <date-picker class="custom-vuedatepicker pt-0 mt-0" v-bind:clearable="false" value-type="YYYY-MM-DD"
                  v-model="addpersonalinfo.passportexpiredate" :disabled="disableall" no-title format="DD/MM/YYYY"
                  :style="{ width: '100%' }">
                </date-picker>
                <!-- <v-menu
                  v-model="menu13"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  fluid
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      autocomplete="off"
                      append-icon="mdi-calendar-month-outline"
                      v-model="computedDateFormatted13"
                      :label="$t('expired_date')"
                      :disabled="disableall"
                      class="kanit-medium"
                      color="#F99D20"
                      persistent-hint
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="addpersonalinfo.passportexpiredate"
                    @change="change()"
                    no-title
                    @input="menu13 = false"
                  ></v-date-picker>
                </v-menu> -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row v-show="!addpersonalinfo.foreignemployee" class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col md="3" style="padding-right: 0">
            <v-text-field autocomplete="off" color="#F99D20" class="empID"
              style="margin-top: 1.5rem; margin-right: -10px" :label="$t('otherinfo')" v-on:keyup="keymonitor"
              v-model="otherimagename" :disabled="disableall"></v-text-field>
          </v-col>
          <v-col md="1" style="padding-left: 0px">
            <v-btn color="#F99D20" v-show="showthis" class="white--text mr-4 text-capitalize mt-5" width="60"
              height="35" :disabled="disableall" @click="goother()">{{ $t("Add") }}</v-btn>
            <v-btn color="#F99D20" v-show="!showthis" class="white--text mr-4 text-capitalize mt-5" width="60"
              height="35" :disabled="disableall" @click="goother()">{{ $t("file") }}</v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="3" style="margin-top: 64px; margin-left: -20px">
        <p style="text-align: center">
          <v-img id="mymyimg" v-show="!ss" :src="imageUrl2" v-model="addpersonalinfo.profile"
            @change="change()" class="preview_img_file" style="
              height: 230px;
              max-width: 230px;
              border: 5px solid #f89d1f;
              background: #ffffff;
              color: #707070;
              border-radius: 50%;
              font-size: 25px;
              margin-left: auto;
              margin-right: auto;
            "></v-img>
          <v-img v-show="ss" :src="imageUrl1" style="
              height: 230px;
              max-width: 230px;
              border: 5px solid #f89d1f;
              background: #ffffff;
              color: #707070;
              border-radius: 50%;
              font-size: 25px;
              margin-left: auto;
              margin-right: auto;
            "></v-img>
        </p>
        <v-layout v-if="changepictrue == false" justify-center align-center>
          <v-btn class="addpic" large :disabled="disableall" color="#F89D1F" width="70%" rounded
            style="float: center; margin-top: 1rem" @click="onPickFile" v-model="imageName">
            <v-icon dark left style="margin-top: 3px">mdi-camera</v-icon>
            <p style="
                margin-top: 1px;
                letter-spacing: 0;
                color: #3c4043;
                font-size: 16px;
              " class="text-capitalize">
              {{ $t("add_picture") }}
            </p>
            <input ref="image" @change="onFilePicked" accept="image/*" type="file" style="display: none"
              id="profile_picture" key="fileInput" />
          </v-btn>
        </v-layout>
        <v-layout v-if="changepictrue == true" justify-center align-center>
          <input ref="imageincropper" v-show="false" @change="onFilePicked" accept="image/*" type="file"
            style="display: none" id="profile_picture" />
          <v-btn class="addpic" large :disabled="disableall" color="#F89D1F" width="70%" rounded
            style="float: center; margin-top: 1rem" @click="EditCropimage()" v-model="imageName">
            <!-- <v-icon dark left style="margin-top: 3px">mdi-camera</v-icon> -->
            <img :src="images.changepic" width="40px" class="mb-1" />
            <p style="
                margin-top: 1px;
                letter-spacing: 0;
                color: #3c4043;
                font-size: 16px;
              " class="text-capitalize">
              {{ $t("ChangePicture") }}
            </p>
            <input ref="image" @change="onFilePicked" accept="image/*" type="file" style="display: none"
              id="profile_picture" />
          </v-btn>
        </v-layout>
      </v-col>
    </v-row>

    <div class="d-flex">
      <div>
        <img width="24px" height="24px" style="margin-top:auto;margin:bottom:auto;"
          src="@/assets/images/Mask Group 22@2x.png" />
      </div>
      <div class="ml-3">
        <label style="font-size: 17px; color: #f89d1f">{{
          $t("employment_information")
        }}</label>
      </div>
    </div>

    <!-- employee information -->
    <v-row>
      <v-col cols="12" lg="12" md="12" class="pb-0">
        <v-col cols="12" xs="12" sm="12" md="3" lg="3" class="pb-0">
          <!-- <label  class="forlabel">{{$t('employeetype')}}*</label> -->
          <v-autocomplete autocomplete="off" class="mt-8" @change="change()" :error-messages="error.errormessageemptype"
            :items="employeetypeitem" item-text="txt" item-value="val" v-model="addpersonalinfo.employeetype"
            append-icon="mdi-chevron-down" :disabled="disableall" color="#F99D20">
            <template v-slot:label>
              <span>
                {{ $t("employeetype")
                }}<span class="red--text"> *</span></span>
            </template>
          </v-autocomplete>
        </v-col>
      </v-col>
      <v-col cols="12" md="12">
        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" xs="12" sm="12" md="3" lg="3" class="mt-4">
            <!-- <label  class="forlabel">{{$t('hired_date')}}*</label> -->
            <label class="custom-label-1" :style="{ color: error.errormessagehiredate ? ' #FF4B55' : '#8a8c8e', }">
              {{ $t("hired_date") }}<span class="red--text"> *</span>
            </label>
            <date-picker :class="error.errormessagehiredate ? 'custom-vuedatepicker-er-mg' : 'custom-vuedatepicker'"
              v-bind:clearable="false" value-type="YYYY-MM-DD" v-model="addpersonalinfo.hiredate" @change="change()"
              :disabled="disableall" :error-messages="error.errormessagehiredate" no-title format="DD/MM/YYYY"
              :editable="false" :style="{ width: '100%' }">
            </date-picker>
            <span v-if="error.errormessagehiredate" class="error-message">{{ error.errormessagehiredate }}</span>
            <!-- <v-menu
              v-model="menu8"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              fluid
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  autocomplete="off"
                  v-model="computedDateFormatted8"
                  append-icon="mdi-calendar-month-outline"
                  :error-messages="error.errormessagehiredate"
                  style="margin-top: 0.5rem"
                  color="#F99D20"
                  class="mt-8"
                  :disabled="disableall"
                  @change="changehiredate()"
                  persistent-hint
                  v-on="on"
                >
                  <template v-slot:label>
                    <span>
                      {{ $t("hired_date")
                      }}<span class="red--text"> *</span></span
                    >
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                @change="change()"
                v-model="addpersonalinfo.hiredate"
                no-title
                @input="menu8 = false"
              ></v-date-picker>
            </v-menu> -->
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <!-- <label  class="forlabel">{{$t('employeetype')}}*</label> -->
            <v-autocomplete autocomplete="off" class="mt-8" style="margin-top: 1.2rem" @change="handlechange"
              :error-messages="error.errormessageemptype" :items="empstatusitem" item-text="txt" item-value="val"
              v-model="addpersonalinfo.employeestatus" append-icon="mdi-chevron-down" :disabled="disableall"
              color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("employee_status")
                  }}<span class="red--text"> *</span></span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <!-- <label class="forlabel">{{ $t("probation_period") }}</label> -->
            <v-text-field autocomplete="off" v-model="addpersonalinfo.probationperiod"
              :error-messages="error.errormessageprobationperiod" color="#F99D20"
              :disabled="disable_probationperiod == true" @keypress="onlyNumber" v-on:keyup="keymonitor"
              @keyup="change()" class="empID" style="margin-top: 2.8rem">
              <template v-slot:label>
                <span>
                  {{ $t("probation_period")
                  }}<span class="red--text"> *</span></span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3" class="mt-4">
            <!-- <label class="forlabel">{{$t('probation_date')}}*</label> -->
            <label class="custom-label-1" :style="{ color: error.errormessageprobationdate ? ' #FF4B55' : '#8a8c8e', }">
              {{ $t("probation_date") }}<span class="red--text"> *</span>
            </label>
            <date-picker
              :class="error.errormessageprobationdate ? 'custom-vuedatepicker-er-mg' : 'custom-vuedatepicker'"
              v-bind:clearable="false" value-type="YYYY-MM-DD" v-model="addpersonalinfo.probationdate"
              @change="change()" :disabled="disableall" :error-messages="error.errormessageprobationdate" no-title
              format="DD/MM/YYYY" :editable="false" :style="{ width: '100%' }">
            </date-picker>
            <span v-if="error.errormessageprobationdate" class="error-message">{{ error.errormessageprobationdate
              }}</span>
            <!-- <v-menu
              v-model="menu9"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              fluid
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  autocomplete="off"
                  v-model="computedDateFormatted9"
                  append-icon="mdi-calendar-month-outline"
                  :error-messages="error.errormessageprobationdate"
                  :disabled="disable_probationperiod == true"
                  style="margin-top: 0.5rem"
                  color="#F99D20"
                  class="mt-8"
                  persistent-hint
                  v-on="on"
                >
                  <template v-slot:label>
                    <span>
                      {{ $t("probation_date")
                      }}<span class="red--text"> *</span></span
                    >
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="addpersonalinfo.probationdate"
                @change="change()"
                no-title
                @input="menu9 = false"
              ></v-date-picker>
            </v-menu> -->
          </v-col>
        </v-row>

        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <v-autocomplete class="empID" style="margin-top: 1.2rem" v-model="addpersonalinfo.department"
              :error-messages="error.errormessagedepartment" @click="GetDepartment()"
              @change="changedepartment(addpersonalinfo.department)" :items="personaldepartmentlist"
              :disabled="disableall" append-icon="mdi-chevron-down" color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("Department") }}<span class="red--text"> *</span></span>
              </template></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <v-autocomplete autocomplete="off" class="empID" style="margin-top: 1.2rem" :items="divisionlist"
              :error-messages="error.errormessagedivision" v-model="addpersonalinfo.division" item-value="division_ID"
              @change="changedivision(addpersonalinfo.division)" :disabled="disableall" append-icon="mdi-chevron-down"
              color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("Division") }}<span class="red--text"> *</span></span>
              </template></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <v-autocomplete class="empID" style="margin-top: 1.2rem" :items="sectionlist"
              :error-messages="error.errormessagesection" @click="changedivisionforsection()" @change="change()"
              :disabled="disableall" v-model="addpersonalinfo.section" item-value="section_ID"
              :item-text="(item) => ` ${item.section_Name}`" append-icon="mdi-chevron-down" color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("Section") }}<span class="red--text"> *</span></span>
              </template></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <!-- <label class="forlabel">{{$t('Position')}}*</label> -->
            <v-autocomplete autocomplete="off" class="empID" style="margin-top: 1.2rem;" @change="change()"
              @click="GetPosition()" :error-messages="error.errormessageposition" :items="positionList"
              v-model="addpersonalinfo.position" item-value="position_ID" :item-text="(item) => `${item.position_Name}`"
              :disabled="disableall" append-icon="mdi-chevron-down" color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("Position") }}<span class="red--text"> *</span></span>
              </template></v-autocomplete>
          </v-col>
        </v-row>

        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <v-autocomplete autocomplete="off" class="empID" @change="change()" :error-messages="error.errormessagelvl"
              v-model="addpersonalinfo.level" :items="levelitem" style="margin-top: 1.2rem" :disabled="disableall"
              append-icon="mdi-chevron-down" color="#F99D20">
              <template v-slot:label>
                <span> {{ $t("level") }}<span class="red--text"> *</span></span>
              </template></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="3" lg="3" class="mt-1 pt-0">
            <!-- <label class="forlabel">{{$t('terminate_date')}}*</label> -->
            <label class="custom-label-1" style="color: #8a8c8e">
              {{ $t("terminate_date") }}<span class="red--text" v-if="inactivestatus">*</span>
            </label>
            <date-picker :class="error.errormessageterminatedate ? 'custom-vuedatepicker-er-mg' : 'custom-vuedatepicker'" class="pt-0 mt-0" v-bind:clearable="false" value-type="YYYY-MM-DD"
            :error-messages="error.errormessageterminatedate" v-model="addpersonalinfo.terminatedate" :disabled="disableall" no-title format="DD/MM/YYYY"
              :style="{ width: '100%' }">
            </date-picker>
            <span v-if="error.errormessageterminatedate" class="error-message">{{ error.errormessageterminatedate
              }}</span>
            <!-- <v-menu
              v-model="menu10"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              fluid
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  autocomplete="off"
                  v-model="computedDateFormatted10"
                  readonly
                  append-icon="close"
                  @click:append="clearterminatedate"
                  style="margin-top: 0.5rem"
                  :label="$t('terminate_date')"
                  color="#F99D20"
                  class="kanit-medium"
                  :disabled="disableall"
                  persistent-hint
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="addpersonalinfo.terminatedate"
                @change="change()"
                no-title
                @input="menu10 = false"
              ></v-date-picker>
            </v-menu> -->
          </v-col>
          <!-- <v-col cols="12" xs="12" sm="12" md="3" lg="3">
       
            <v-menu
              v-model="menu11"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              fluid
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  autocomplete="off"
                  :label="$t('terminate_effective_date')"
                  v-model="computedDateFormatted11"
                  readonly
                  style="margin-top: 0.5rem"
                  color="#F99D20"
                  :disabled="disableall"
                  class="kanit-medium"
                  persistent-hint
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="addpersonalinfo.terminateeffectdate"
                @change="change()"
                no-title
                @input="menu11 = false"
              ></v-date-picker>
            </v-menu>
          </v-col> -->
          <!-- <v-col cols="12" xs="12" sm="12" md="3" lg="3">
    

            <v-select
              autocomplete="off"
              class="empID"
              v-model="addpersonalinfo.calendartype"
              :error-messages="error.errormessageworkdaycalendar"
              @change="change()"
              :label="$t('workday_calendar')"
              style="margin-top: 1.2rem"
              :items="calendartypeitem"
              :item-text="(item) => item.text"
              :item-value="(item) => item.val"
              :disabled="disableall"
              append-icon="mdi-chevron-down"
              color="#F99D20"
            ></v-select>
          </v-col> -->
          <v-col cols="12" xs="12" sm="6" md="3" lg="3">
            <!-- <v-text-field
              v-on:keyup="keymonitor"
              :label="$t('shiftcode')"
              v-model="addpersonalinfo.shiftcode"
              :disabled="disableall"
              readonly
              color="#F99D20"
              class="mt-2"
            ></v-text-field>-->

            <v-autocomplete class="empID" v-model="addpersonalinfo.shiftcode" :error-messages="error.errormessagestatus"
              @change="change()" style="margin-top: 1.2rem" append-icon="mdi-chevron-down" color="#F99D20"
              :disabled="disableall" :items="ShiftCodeList" :item-text="(item) => item.shift_Code"
              :item-value="(item) => item.shift_ID" :value="DefaultShiftCode.shift_Code">
              <template v-slot:item="data">
                <template>

                  <v-list-item-content>
                    <v-list-item>{{ data.item.shift_Code }}<span style="color:#2196F3; padding-left:5px">{{ " : "
                      + data.item.start_Time +' - '+data.item.end_Time}}</span></v-list-item>
                  </v-list-item-content>
                </template>
              </template>

              <template v-slot:label>
                <span>
                  {{ $t("Shift_Code") }}</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="3" lg="3">
            <v-autocomplete class="empID" v-model="addpersonalinfo.status" :error-messages="error.errormessagestatus"
              @change="change()" style="margin-top: 1.2rem" :items="statusitems" item-text="text" :disabled="disableall"
              item-value="val" append-icon="mdi-chevron-down" color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("status") }}<span class="red--text"> *</span></span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <!--Report To Dropdown-->
        <v-row class="pl-md-0" style="margin-left:0px; margin-right:10px">

          <v-col cols="12" sm="3" md="3">

            <v-autocomplete class="empID" v-model="addpersonalinfo.ReportToEmployeeId" item-value="employee_ID"
              :disabled="disableall" :items="TempReportToList" :item-text="(item) => ` ${item.employee_Name}`"
              :error-messages="error.errormessagereportid" style="margin-top: 1.2rem" append-icon="mdi-chevron-down"
              dense color="#F99D20">
              <template v-slot:selection="data">

                <span style="font-size:17px">{{ data.item.employee_Name }}</span>

              </template>
              <template v-slot:item="data">
                <template>
                  <v-list-item-avatar size="30px">
                    <img :src="data.item.profile_Pic">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ data.item.nickname == null ? data.item.employee_Name : data.item.employee_Name + '('+data.item.nickname+')'}}</v-list-item-title>
                    <p style="font-size:11px">{{ data.item.position_Name }}</p>
                  </v-list-item-content>
                </template>
              </template>
              <template v-slot:label>
                <span>
                  {{ $t("Supervisor") }}<span class="red--text"> *</span>
                </span>
              </template>
            </v-autocomplete>

          </v-col>
        </v-row>

        <!--   <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
           <v-col cols="12" md="2" sm="6" lg="4">
               <div class="mt-6" style="color: #8a8c8e; width:1400px" >
                    {{ $t("ReportTo") }}
                    <span class="red--text mt-6 ml-1"> *</span>
                  </div>
          </v-col> 

          <v-col cols="12" xs="12" sm="6" md="5" lg="5" xl="5" class="pr-0">
            <div class="d-flex">
              <v-row class="pa-0">
                <v-col
                  cols="12"
                  sm="4"
                  md="5"
                  lg="4"
                  class="pa-0"
                  style="margin-top: -0.5rem"
                >
                  <v-card-text class="mt-6" style="color: #8a8c8e">
                    {{ $t("ReportTo") }}
                    <span class="red--text mt-6 ml-1"> *</span>
                  </v-card-text>
                </v-col>
                <v-col cols="3" sm="6" md="5" lg="8" class="pa-0">
                  <div class="mt-5">
                    <v-btn
                      :disabled="disableall"
                      color="#F99D20"
                      class="white--text text-capitalize fix-btn"
                      style="font-weight: normal"
                      width="160"
                      @click="ReportDialog = true"
                      max-height="34"
                    >
                      <img
                        src="@/assets/images/account@2x.png"
                        width="25"
                        class="pr-2"
                      />
                      {{ $t("SelectEmployee") }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>

            <div style="margin-top: 3px">
              <p
                style="font-size: 13px; color: #ff5252; text-align: center"
                class="pl-6"
              >
                {{ error.errormessagereportid }}
              </p>
            </div>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="3"
            lg="3"
            xl="2"
            v-if="addpersonalinfo.ReportToEmployeeId != 0"
          >
            <div class="d-flex fix-txt rp">
              <div class="fix-d ml-2" style="color: #8a8c8e; margin-top: 1rem">
                {{ addpersonalinfo.ReportToEmployeeCode }}
              </div>
              <div
                class="fix-d"
                style="color: #8a8c8e; padding-left: 1rem; margin-top: 1rem"
              >
                {{ addpersonalinfo.ReportToEmployeeName }}
              </div>
            </div>
          </v-col>
        </v-row> -->
        <v-row class="pl-md-0 mb-6" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" xs="12" sm="6" md="3" l="3">
            <v-btn color="#F99D20" class="white--text text-capitalize mt-4 px-5" block max-height="35" max-width="220"
              min-width="0" :disabled="disableall" @click="departmenttransfer()">{{ $t("departmenttransferhistory")
              }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- address -->
    <div class="d-flex">
      <div>
        <img width="24px" height="24px" style="margin-top:auto;margin:bottom:auto;"
          src="@/assets/images/Mask Group 23@2x.png" />
      </div>
      <div class="ml-3">
        <label style="font-size: 17px; color: #f89d1f" class="empID">{{
          $t("address")
        }}</label>
      </div>
    </div>

    <v-row class="mt-3">
      <v-col cols="12" md="12">
        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col class="mt-4" cols="12" xs="12" sm="12" md="3" lg="3">
            <v-autocomplete class="empID" @change="changecountry() || change()"
              :error-messages="error.errormessagecountry" style="margin-top: 0; font-size: 17px" :items="CountryList"
              v-model="addpersonalinfo.country" item-value="country_ID" :item-text="(item) => ` ${item.country_Name}`"
              :disabled="disableall" append-icon="mdi-chevron-down" color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("Country") }}<span class="red--text"> *</span></span>
              </template></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <v-autocomplete class="empID invisible-scrollbar" :error-messages="error.errormessageprovince"
              style="margin-top: 0.95rem; font-size: 17px" @change="changeprovince() || change()" :items="ProvinceList"
              v-model="addpersonalinfo.province" item-value="province_ID"
              :item-text="(item) => ` ${item.province_Name}`" append-icon="mdi-chevron-down" :disabled="disableall"
              color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("Province") }}<span class="red--text"> *</span></span>
              </template></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <v-autocomplete class="empID" :items="Districtlist" :error-messages="error.errormessagedistrict"
              @change="changedistrict() || change()" v-model="addpersonalinfo.district" item-value="district_ID"
              :item-text="(item) => ` ${item.district_Name}`" style="margin-top: 0.95rem; font-size: 17px"
              append-icon="mdi-chevron-down" color="#F99D20" :disabled="disableall">
              <template v-slot:label>
                <span>
                  {{ $t("District") }}<span class="red--text"> *</span></span>
              </template></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <v-autocomplete class="empID" v-model="addpersonalinfo.subdistrict"
              :error-messages="error.errormessagesubdistrict" @change="changesubdistrict() || change()"
              :items="Subdistrictlist" item-value="sub_District_ID" :item-text="(item) => ` ${item.sub_District_Name}`"
              style="margin-top: 0.95rem; font-size: 17px" append-icon="mdi-chevron-down" :disabled="disableall"
              color="#F99D20">
              <template v-slot:label>
                <span>
                  {{ $t("subdistrict") }}<span class="red--text"> *</span></span>
              </template></v-autocomplete>
          </v-col>
        </v-row>

        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" xs="12" sm="12" md="3" lg="3" class="mt-2">
            <v-autocomplete class="empID" :items="Postalcodelist" @change="change()" item-value="postal_Code_ID"
              :error-messages="error.errormessagepostalcode" :item-text="(item) => ` ${item.postal_Code}`"
              v-model="addpersonalinfo.postalcode" style="margin-top: 0.95rem; font-size: 17px"
              append-icon="mdi-chevron-down" color="#F99D20" :disabled="disableall">
              <template v-slot:label>
                <span>
                  {{ $t("postalcode") }}<span class="red--text"> *</span></span>
              </template></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3" class="mt-2">
            <v-text-field autocomplete="off" v-model="addpersonalinfo.housenumber"
              :error-messages="error.errormessagehouse" v-on:keyup="keymonitor"
              style="margin-top: 0.95rem; font-size: 17px" color="#F99D20" class="empID" :disabled="disableall">
              <template v-slot:label>
                <span>
                  {{ $t("house_number")
                  }}<span class="red--text"> *</span></span>
              </template></v-text-field>
          </v-col>
        </v-row>
        <v-row class="pl-md-0" style="margin-left: 0px; margin-right: 10px">
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <v-text-field autocomplete="off" color="#F99D20" v-on:keyup="keymonitor"
              :error-messages="error.errormessagetele" class="empID" v-model="addpersonalinfo.telephonenum"
              style="margin-top: 1.5rem" :label="$t('telephone_number')" :disabled="disableall"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <v-text-field autocomplete="off" color="#F99D20" v-on:keyup="keymonitor" class="empID"
              @keypress="onlyNumber" :error-messages="error.errormessagemobile" v-model="addpersonalinfo.mobile_number"
              :disabled="disableall" style="margin-top: 1.5rem">
              <template v-slot:label>
                <span>
                  {{ $t("mobile_number")
                  }}<span class="red--text"> *</span></span>
              </template></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6">
            <v-text-field autocomplete="off" v-model="addpersonalinfo.email" v-on:keyup="keymonitor"
              :error-messages="error.errormessageemail" :disabled="disableall" color="#F99D20" class="empID"
              style="margin-top: 1.5rem">
              <template v-slot:label>
                <span> {{ $t("email") }}<span class="red--text"> *</span></span>
              </template></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div style="
        margin-top: 3rem;
        padding-bottom: 3rem;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
      ">
      <v-row v-show="showedit">
        <v-col offset-md="10">
          <v-btn class="pa-2 text_transform_none float-right btn_edit commonsavebtn" :disabled="$route.path == '/selfservice/PersonalProfile/PersonalInformation'
              ? permission.edit
              : permission_management.edit
            " @click="showandhide">{{ $t("edit") }}</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col offset-md="10" v-show="showsave">
          <v-btn class="pa-2 text_transform_none float-right btn_edit commonsavebtn"
            :disabled="permission_management.add" @click="AddPersonalinfo()">{{ $t("save") }}</v-btn>
        </v-col>
      </v-row>
      <v-row v-show="showbyid">
        <v-spacer></v-spacer>

        <div class="d-flex">
          <v-btn color="#3C4043" class="pa-2 mr-5 text_transform_none btn_fix commoncancelbtn" @click="hidethis"
            outlined text>{{ $t("cancel") }}</v-btn>
          <v-btn class="pa-2 text_transform_none btn_fix commonsavebtn" :disabled="permission_management.edit"
            @click="UpdatePersonalinfo()">{{ $t("save") }}</v-btn>
        </div>
      </v-row>
      <v-row v-show="showbysid">
        <v-spacer></v-spacer>
        <div style="margin-right: 1.5rem">
          <v-btn class="pa-2 mr-5 text_transform_none commoncancelbtn" @click="hidethis" outlined text>{{ $t("cancel")
            }}</v-btn>
          <v-btn class="pa-2 text_transform_none save_btn commonsavebtn" :disabled="permission.edit"
            @click="UpdatePersonalinfowithhSid()">{{ $t("save") }}</v-btn>
        </div>
      </v-row>
      <v-row v-show="showbycode">
        <v-spacer></v-spacer>
        <div style="margin-right: 1.5rem">
          <v-btn class="pa-2 mr-5 text_transform_none commoncancelbtn" @click="hidethis" text>{{ $t("cancel") }}</v-btn>
          <v-btn class="pa-2 text_transform_none save_btn commonsavebtn" :disabled="permission_management.edit"
            @click="UpdatePersonalinfoWithEmpcode()">{{ $t("save") }}</v-btn>
        </div>
      </v-row>
    </div>
    <!-- crop dialog -->
    <v-dialog v-model="cropDialog" persistent width="550">
      <v-card style="border-radius: 15px" class="overflow-x-hidden overflow-y-hidden">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn @click="CancelCropdialog()" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="justify-content:center pa-12">
          <v-row>
            <v-col cols="12 pb-0" class="d-flex align-center justify-center cropper-container">
              <cropper v-if="!cropped" @change="changecropper" class="cropper" ref="cropper" :src="cropperSrc"
                :stencil-props="{
                  aspectRatio: 1 / 1,
                  movable: true,
                  resizable: true,
                }" />
            </v-col>

            <v-col cols="12" class="d-flex align-center justify-center cropper-container">
              <v-img v-if="cropped == true" :src="getcroppedphoto" height="350px" width="256" aspect-ratio="1.4" style="
                  height: 230px;
                  max-width: 230px;
                  border: 5px solid #f89d1f;
                  background: #ffffff;
                  color: #707070;
                  border-radius: 50%;
                  font-size: 25px;
                  margin-left: auto;
                  margin-right: auto;
                ">
              </v-img>
            </v-col>
          </v-row>
          <v-row v-if="cropped == false">
            <v-col cols="3"></v-col>
            <v-col>
              <div style="justify-content: center">
                <v-btn class="mr-3 text-capitalize black--text fix-btn" width="150" max-height="35" style="
                    font-family: kanit, Regular;
                    font-weight: normal;
                    color: black;" 
                    @click="onpickchangephoto">
                  {{ $t("ChangePhoto") }}
                </v-btn>
                <v-btn @click="Deleteconfirmdialog = true" text>
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="cropped == true">
            <v-col cols="4"></v-col>
            <v-col>
              <div style="justify-content: center">
                <v-btn class="mr-3 text-capitalize black--text fix-btn" width="150" max-height="35" style="
                    font-family: kanit, Regular;
                    font-weight: normal;
                    color: black;
                  " @click="onPickFile">
                  {{ $t("Choosefile") }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <hr color="#F99D20" class="mt-5" />
          <v-row class="mt-5">
            <v-spacer></v-spacer>
            <!-- <v-btn
              @click="Oncrop()"
              depressed
              color="#0FA7D8"
              class="white--text"
              v-if="!cropped"
            >
              <img
                src="@/assets/images/Icon ionic-md-crop copy.png"
                class="pr-1"
              />
              Crop</v-btn
            > -->
            <v-btn class="mr-3 text-capitalize fix-btn commoncancelbtn" outlined text
              @click="CancelCroppedimage">
              {{ $t("Cancel") }}
            </v-btn>
            <!-- @click="toggleDialog" -->
            <v-btn @click="SaveCroppedimage" class="mr-3 text-capitalize commonsavebtn fix-btn">
              {{ $t("Save") }}
            </v-btn>
          </v-row>
        </div>
      </v-card>
    </v-dialog>

    <!-- Loadingdialog -->
    <LoadingDialog :LoadingDialog="loadingdialog"></LoadingDialog>

    <v-dialog v-model="Deleteconfirmdialog" persistent max-width="400">
      <v-card style="border-radius: 15px" class="pa-5">
        <v-card-title class="pb-0">
          <v-spacer></v-spacer>
          <img width="45px" height="45px" style="margin-top:auto;margin:bottom:auto;"
            src="@/assets/images/trashcan.png" />
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col align="center" cols="12" class="pt-4">
                {{ $t("deleteconfirmation") }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <hr color="#F99D20" />
        <v-card-actions class="pb-6">
          <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
          <v-btn color="darken-1" class="mr-3 text-capitalize fix-btn" max-height="35" text
            @click="Deleteconfirmdialog = false">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn color="#F99D20" class="text-capitalize white--text" max-height="35" @click="DeletePhoto()">{{
            $t("DeletePhoto") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
import enurl from "@/api/environment";
import store from "@/store";
import LogTrace from "@/function/Log.js";
import CheckViewAddEdit from "@/function/RolePermissions.js";
import { utils } from "@/function/AuthenticatedRedirect.js";
import _ from "lodash";
import moment from "moment";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import LoadingDialog from "@/components/Loading.vue";

export default {
  mixins: [CheckViewAddEdit, LogTrace, utils],
  components: {
    Cropper, DatePicker, LoadingDialog
  },
  data: (vm) => ({
    ReportDialog: false,
    showmycropper: false,
    showdefault: true,
    showcrop: false,
    Deleteconfirmdialog: false,
    changepictrue: false,
    isBase64Image: false,
    mybase64img: "",
    cropDialog: false,
    cropperSrc: null,
    beforecroppersrc: null,
    cropperImageSrc: "",
    croppedimage: "",
    cropped: false,
    dynamicAspectRatio: null,
    permission: {
      add: true,
      edit: true,
    },
    permission_management: {
      add: true,
      edit: true,
    },
    headers: [
      {
        text: "Name",
        value: "fullName",
        align: "left",
        sortable: false,
      },
      {
        text: "Employee ID",
        value: "employee_ID",
        align: "right",
        sortable: false,
      },
      {
        text: "Personal ID",
        value: "personalId_Number",
        align: "right",
        sortable: false,
      },
    ],
    showthis: true,
    disableall: false,
    loadingdialog: false,
    changetext: false,
    showbyid: false,
    showbysid: false,
    showforcode: false,
    showedit: false,
    showsave: false,
    showbycode: false,
    hideandshow: false,
    hideandshowsid: false,
    url: enurl.apiUrl,
    checked: false,
    editotherfile: false,
    isninja: false,
    show: false,
    date6: "",
    date7: "",
    date8: "",
    date9: "",
    date10: "",
    date11: "",
    date12: "",
    date13: "",
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    allowedDates: (val) => val <= new Date().toISOString().substr(0, 10),
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
    menu12: false,
    menu13: false,
    ss: false,
    departmentList: [],
    divisionList: [],
    sectionList: [],
    positionList: [],
    ShiftCodeList: [],
    DefaultShiftCode: [],
    AddressList: [],
    Postalcodelist: [],
    Subdistrictlist: [],
    Districtlist: [],
    ProvinceList: [],
    CountryList: [],
    ReportToList: [],
    TempReportToList: [],
    SearchReportTo: [],
    TempList: [],
    educationBackground: [],
    shortTraining: [],
    languages: [],
    tempedu: [],
    tempeSt: [],
    tempeLg: [],
    mypicture:
      "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",
    roleitems: ["HR Manager", "HR", "Customer Admin", "Staff"],
    levelitem: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
    calendartypeitem: [
      { text: "Shift staff-monthly", val: 1 },
      { text: "Shift staff-weekly", val: 2 },
      { text: "Shift staff- weekly & monthly", val: 3 },
      { text: "Shift staff-hourly", val: 4 },
      { text: "Office staff-monthly", val: 5 },
      { text: "Office Staff-weekly", val: 6 },
      { text: "Office Staff-Weekly & Monthly", val: 7 },
    ],
    items1: [1, 2, 3, 4],
    seen: true,
    image: null,
    image1: null,
    imageName: "",
    imageUrl: "",
    imageUrl1: "",
    imageUrl2: "",
    imageFile: "",
    files: null,
    files1: null,
    imageName1: "",
    imageName2: "",
    myimage: null,
    otherimagename: null,
    workpermitname: null,
    passport: null,
    personalname: null,
    passportUrl: "",
    otherinfoUrl: "",
    workpermitUrl: "",
    personalIdUrl: "",
    forlocalstore: [],
    PersonalList: [],
    SupervisorList: [],
    workimgsend: "",
    forsplit: null,
    eId: "",
    imgname: "",
    personaldepartmentlist: [],
    otherinfomation: "Other Information",
    mydepartmentlist: [],
    currentdepartment: [],
    returnSrc: "",
    inactivestatus: false,
    error: {
      errormessageempid: "",
      errormessageprefix: "",
      errormessagename: "",
      errormessagelastname: "",
      errormessagegender: "",
      errormessagereligion: "",
      errormessageDOB: "",
      errormessageage: "",
      errormessagemartialstatus: "",
      errormessageexpireddate: "",
      errormessagetaxpayer: "",
      errormessageemptype: "",
      errormessagehiredate: "",
      errormessageprobationperiod: "",
      errormessageprobationdate: "",
      errormessagedepartment: "",
      errormessagedivision: "",
      errormessagesection: "",
      errormessageposition: "",
      errormessagesupervisor: "",
      errormessagelvl: "",
      errormessageterminatedate: "",
      errormessageterminateeffectivedate: "",
      errormessageworkdaycalendar: "",
      errormessageshiftcode: "",
      errormessagestatus: "",
      errormessagecountry: "",
      errormessageprovince: "",
      errormessagedistrict: "",
      errormessagesubdistrict: "",
      errormessagepostalcode: "",
      errormessagehouse: "",
      errormessagetele: "",
      errormessagemobile: "",
      errormessagepassport: "",
      errormessageemail: "",
      errormessagepersonalid: "",
      errormessagepersonalidNumber: "",
      errormessagereportid: "",
    },
    addpersonalinfo: {
      employeecode: null,
      prefix: null,
      firstname: null,
      lastname: null,
      nickname: null,
      gender: null,
      religion: null,
      DOB: "",
      age: null,
      martialstatus: null,
      expired_date: null,
      taxpayerID: null,
      foreignemployee: false,
      workpermitexpiredate: null,
      passportexpiredate: null,
      employeetype: null,
      hiredate: "",
      probationperiod: null,
      probationdate: "",
      department: null,
      division: null,
      divisonID: null,
      sectionID: null,
      section: null,
      profile: null,
      position: null,
      supervisorname: "",
      level: null,
      terminatedate: null,
      terminateeffectdate: null,
      calendartype: 1,
      shiftcode: null,
      status: 1,
      housenumber: null,
      subdistrict: "",
      district: "",
      province: "",
      country: "",
      postalcode: "",
      telephonenum: null,
      mobile_number: null,
      email: null,
      personalID_Number: "",
      selected: [],
      ReportToEmployeeId: null,
      ReportToEmployeeName: null,
      ReportToEmployeeCode: null,
      Activeemployee: 0,
      PckgEmployeee: 0,
      duplicatecode: false,
      employeestatus: "Probation"

    },
    disable_probationperiod: true,
    activeemp: 0,
    images: {
      edit: require("@/assets/images/Mask Group 178.png"),
      delete: require("@/assets/images/Mask Group 177.png"),
      changepic: require("@/assets/images/Edit_icon-icons.com_71853.png"),
    },
    empCount: 0,
    disablepersonalID: false,
    divisionlist: [],
    sectionlist: [],
    EducationList: [],
    ShortTrainingList: [],
    LanguageList: [],
    Activeemplist: [],
    resetbtn: true,
    defaultprofile: false,
  }),

  watch: {
    SearchReportTo(e) {
      this.searchReport(e);
    },

    "addpersonalinfo.foreignemployee"(v) {
      if (v == true) {
        this.disablepersonalID = true;
        this.addpersonalinfo.personalID_Number = "";
        this.personalIdUrl = "";
        this.error.errormessagepersonalid = "";
        this.error.errormessagepassport = "";
        this.error.errormessagetaxpayer = "";
      }
      else {
        this.disablepersonalID = false;
        this.addpersonalinfo.personalID_Number = "";
        this.error.errormessagepersonalid = "";
        this.passport = "";
        this.error.errormessagepassport = "";
      }
    },

    "addpersonalinfo.employeecode"(v) {
      if (v) this.error.errormessageempid = "";
    },

    "addpersonalinfo.prefix"(v) {
      if (v) this.error.errormessageprefix = "";
    },

    "addpersonalinfo.firstname"(v) {
      if (v) this.error.errormessagename = "";
    },

    "addpersonalinfo.lastname"(v) {
      if (v) this.error.errormessagelastname = "";
    },

    "addpersonalinfo.gender"(v) {
      if (v) this.error.errormessagegender = "";
    },

    "addpersonalinfo.religion"(v) {
      if (v) this.error.errormessagereligion = "";
    },

    "addpersonalinfo.DOB"(v) {
      if (v) this.error.errormessageDOB = "";
    },

    "addpersonalinfo.martialstatus"(v) {
      if (v) this.error.errormessagemartialstatus = "";
    },

    "addpersonalinfo.expired_date"(v) {
      if (v) this.error.errormessageexpireddate = null;
    },

    "addpersonalinfo.taxpayerID"(v) {
      if (v) this.error.errormessagetaxpayer = null;
    },

    "addpersonalinfo.employeetype"(v) {
      if (v) this.error.errormessageemptype = "";
    },

    "addpersonalinfo.hiredate"(v) {
      if (v) this.error.errormessagehiredate = "";
    },

    "addpersonalinfo.probationperiod"(v) {
      if (v) this.error.errormessageprobationperiod = "";
    },

    "addpersonalinfo.probationdate"(v) {
      if (v) this.error.errormessageprobationdate = "";
    },

    "addpersonalinfo.department"(v) {
      if (v) this.error.errormessagedepartment = "";
    },

    "addpersonalinfo.division"(v) {
      if (v) this.error.errormessagedivision = "";
    },

    "addpersonalinfo.section"(v) {
      if (v) this.error.errormessagesection = "";
    },

    "addpersonalinfo.position"(v) {
      if (v) this.error.errormessageposition = "";
    },

    "addpersonalinfo.level"(v) {
      if (v) this.error.errormessagelvl = "";
    },

    "addpersonalinfo.terminatedate"(v) {
      if (v) this.error.errormessagesection = "";
    },

    "addpersonalinfo.status"(v) {
      if (v) this.error.errormessagestatus = "";
    },

    "addpersonalinfo.country"(v) {
      if (v) this.error.errormessagecountry = "";
    },

    "addpersonalinfo.province"(v) {
      if (v) this.error.errormessageprovince = "";
    },

    "addpersonalinfo.district"(v) {
      if (v) this.error.errormessagedistrict = "";
    },

    "addpersonalinfo.subdistrict"(v) {
      if (v) this.error.errormessagesubdistrict = "";
    },

    "addpersonalinfo.postalcode"(v) {
      if (v) this.error.errormessagepostalcode = "";
    },

    "addpersonalinfo.housenumber"(v) {
      if (v) this.error.errormessagehouse = "";
    },

    "addpersonalinfo.mobile_number"(v) {
      if (v) this.error.errormessagemobile = "";
    },

    "addpersonalinfo.email"(v) {
      if (v) this.error.errormessageemail = "";
    },

    "addpersonalinfo.ReportToEmployeeId"(v) {
      if (v) this.error.errormessagereportid = "";
    },

    "addpersonalinfo.personalID_Number"(v) {
      if (v) this.error.errormessagepersonalid = "";
    },
  },

  computed: {
    getcroppedphoto() {
      return this.croppedimage;
    },

    religionitems() {
      return [
        { val: "Buddhism", txt: this.$t("Buddhism") },
        { val: "Islam", txt: this.$t("Islam") },
        { val: "Christianity", txt: this.$t("Christianity") },
        { val: "Hinduism", txt: this.$t("Hinduism") },
        { val: "Sikhism", txt: this.$t("Sikhism") },
        { val: "Judaism", txt: this.$t("Judaism") },
        { val: "Atheism", txt: this.$t("Atheism") },
      ];
    },

    employeetypeitem() {
      return [
        { val: "Full Time", txt: this.$t("Full Time") },
        { val: "Daily", txt: this.$t("daily") },
        { val: "Part-time", txt: this.$t("Part-time") },
        { val: "Contract", txt: this.$t("Contract") },
        { val: "Fixed Pay", txt: this.$t("Fixed Pay") },
      ];
    },

    empstatusitem() {
      return [
        { val: "Probation", txt: this.$t("Probation") },
        { val: "Permanent", txt: this.$t("Permanent") },
        { val: "Resign", txt: this.$t("Resign") },
      ];
    },

    statusitems() {
      return [
        { text: this.$t("Active"), val: 1 },
        { text: this.$t("Inactive"), val: 2 },
      ]
    },

    genderitems() {
      return [
        { val: "Male", txt: this.$t("Male") },
        { val: "Female", txt: this.$t("Female") },
      ];
    },

    mstatusitems() {
      return [
        { val: "Single", txt: this.$t("Single") },
        { val: "Married", txt: this.$t("Married") },
        { val: "Divorced", txt: this.$t("Divorced") },
        { val: "Widowed", txt: this.$t("Widowed") },
      ];
    },

    computedDateFormatted6() {
      return this.formatDate(this.addpersonalinfo.DOB);
    },

    computedDateFormatted7() {
      return this.formatDate(this.addpersonalinfo.expired_date);
    },

    computedDateFormatted8() {
      return this.formatDate(this.addpersonalinfo.hiredate);
    },

    computedDateFormatted9() {
      return this.formatDate(this.addpersonalinfo.probationdate);
    },

    computedDateFormatted10() {
      return this.formatDate(this.addpersonalinfo.terminatedate);
    },

    computedDateFormatted11() {
      return this.formatDate(this.addpersonalinfo.terminateeffectdate);
    },

    computedDateFormatted12() {
      return this.formatDate(this.addpersonalinfo.workpermitexpiredate);
    },

    computedDateFormatted13() {
      return this.formatDate(this.addpersonalinfo.passportexpiredate);
    },
  },

  async mounted() {
    if (this.$route.path === '/PersonnelManagement/NewEmployee/NewPersonalInformation') {
      this.disable_probationperiod = false;
    }
    else {
      this.disable_probationperiod = true;
    }
    this.getProbationDay();
    if (localStorage.myhideandshow) {
      this.hideandshow = localStorage.myhideandshow;
    }
    //this.GetCompany();
    this.GetPersonal();
    this.GetCountry();
    this.GetallDepartment();
    //this.GetDepartment();
    this.GetDivision();
    this.GetSectiion();
    //this.GetPosition();
    this.GetAllPosition();
    this.GetShiftCode();
    // this.GetSupervisor();
    this.getpersonalinfo();
    this.getEd();
    this.getST();
    this.getLang();
    await this.GetReportTo();
    this.permission = this.CheckViewAddEdit(123, 124, 125);
    this.permission_management = this.CheckViewAddEdit(199, 200, 201);
    this.disable_btn();
    let myimg = localStorage.localprofile;
    if (myimg != undefined) {
      this.imageUrl = myimg;
    }
  },

  created() {
    if (this.imageUrl1 == "")
    {
      this.ss = true;
      this.imageUrl1 = "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group 3166.png";
    }
    if (this.$route.params.id != "undefined")
    {
      this.otherimagename = localStorage.fortext;
      if (localStorage.fortext == undefined)
      {
        this.otherimagename = "";
      }
      this.otherinfomation = localStorage.othername;
      this.workpermitUrl = localStorage.localworkeditpermitUrl;
      if (localStorage.editfilename != null && localStorage.editfilename != undefined)
      {
        let personal = localStorage.editfilename;
        this.myimage = personal;
      }
      if (localStorage.filename != null)
      {
        let personal = localStorage.filename;
        this.myimage = personal;
      }
      this.passportUrl = localStorage.localeditPassportUrl;
      this.otherinfoUrl = localStorage.localeditotherinfoUrl;
      if (this.otherinfoUrl != undefined)
      {
        this.showthis = false;
      }
      if (localStorage.LocaleditPersonalidUrl != null)
      {
        this.personalIdUrl = localStorage.LocaleditPersonalidUrl;
      }
      else
      {
        this.personalIdUrl = localStorage.LocalPersonalidUrl;
      }
    }
    else if (this.$route.path == "/selfservice/PersonalProfile/PersonalInformation")
    {
      this.otherimagename = localStorage.fortext;
      let personalname = localStorage.filename;
      this.myimage = personalname;
      let aa = localStorage.aa;
      this.addpersonalinfo.country = aa;
      this.passportUrl = localStorage.localPassportUrl;
      this.otherinfoUrl = localStorage.localotherinfoUrl;
      if (this.otherinfoUrl != undefined)
      {
        this.showthis = false;
      }
      this.workpermitUrl = localStorage.localworkpermitUrl;
      this.personalIdUrl = localStorage.LocalPersonalidUrl;
    }
    else
    {
      this.getpersonalinfo();
      this.otherimagename = localStorage.fortext;
      let personalname = localStorage.filename;
      this.myimage = personalname;
      let aa = localStorage.aa;
      this.addpersonalinfo.country = aa;
      this.passportUrl = localStorage.localPassportUrl;
      this.otherinfoUrl = localStorage.localotherinfoUrl;
      if (this.otherinfoUrl != undefined)
      {
        this.showthis = false;
      }
      this.workpermitUrl = localStorage.localworkpermitUrl;
      this.personalIdUrl = localStorage.LocalPersonalidUrl;
    }
    let ww = localStorage.ww;
    this.addpersonalinfo.DOB = ww;
    let ii = localStorage.ii;
    this.addpersonalinfo.age = ii;
    let reporttask = JSON.parse(localStorage.getItem("reportinfo"));
    if (reporttask != null)
    {
      this.addpersonalinfo.ReportToEmployeeId = reporttask.reportid;
      this.addpersonalinfo.ReportToEmployeeName = reporttask.reportname;
      this.addpersonalinfo.ReportToEmployeeCode = reporttask.reportcode;
    }
    let taskSt = JSON.parse(localStorage.getItem("gg"));
    if (taskSt != null)
    {
      this.addpersonalinfo.employeecode = taskSt.employeecode;
      this.addpersonalinfo.firstname = taskSt.firstname;
      this.addpersonalinfo.lastname = taskSt.lastname;
      this.addpersonalinfo.nickname = taskSt.nickname;
      this.addpersonalinfo.prefix = taskSt.prefix;
      this.addpersonalinfo.taxpayerID = taskSt.taxid;
      this.addpersonalinfo.probationperiod = taskSt.probationperiod;
      this.addpersonalinfo.personalID_Number = taskSt.personalid;
      this.addpersonalinfo.housenumber = taskSt.house;
      this.addpersonalinfo.telephonenum = taskSt.tele;
      this.addpersonalinfo.mobile_number = taskSt.mobile;
      this.addpersonalinfo.email = taskSt.email;
      this.addpersonalinfo.personalID_Number = taskSt.personalID_Number;
      this.passport = taskSt.passport;
      this.workpermitname = taskSt.workpermitname;
    }
    let taskchange = JSON.parse(localStorage.getItem("gf"));
    if (taskchange != null)
    {
      this.addpersonalinfo.gender = taskchange.gender;
      this.addpersonalinfo.foreignemployee = taskchange.foreignemployee;
      this.addpersonalinfo.religion = taskchange.religion;
      this.addpersonalinfo.DOB = taskchange.DOB;
      this.addpersonalinfo.martialstatus = taskchange.status;
      this.addpersonalinfo.expired_date = taskchange.expireddate;
      this.addpersonalinfo.workpermitexpiredate = taskchange.workpermitexpire;
      this.addpersonalinfo.passportexpiredate = taskchange.passsportexpire;
      this.addpersonalinfo.employeetype = taskchange.employeetype;
      this.addpersonalinfo.hiredate = taskchange.hireddate;
      this.addpersonalinfo.probationdate = taskchange.probationdate;
      this.addpersonalinfo.department = taskchange.department;
      this.changedepartment(this.addpersonalinfo.department);
      this.addpersonalinfo.division = taskchange.division;
      this.changedivision(this.addpersonalinfo.division);
      this.addpersonalinfo.section = taskchange.section;
      this.addpersonalinfo.sectionID = this.addpersonalinfo.section;
      this.addpersonalinfo.position = taskchange.position;
      this.addpersonalinfo.level = taskchange.level;
      this.addpersonalinfo.terminatedate = taskchange.terminatedate;
      this.addpersonalinfo.terminateeffectdate = taskchange.terminateeffectdate;
      this.addpersonalinfo.calendartype = taskchange.workdaycalendar;
      this.addpersonalinfo.shiftcode = taskchange.shiftcode;
      this.addpersonalinfo.status = taskchange.empstatus;
      this.addpersonalinfo.postalcode = taskchange.postalcode;
      this.addpersonalinfo.country = taskchange.country;
      if (this.addpersonalinfo.country != null && this.addpersonalinfo.country != "")
      {
        this.changecountry();
      }
      this.addpersonalinfo.province = taskchange.province;
      if (this.addpersonalinfo.province != null)
      {
        this.changeprovince();
      }
      this.addpersonalinfo.district = taskchange.district;
      if (this.addpersonalinfo.district != null)
      {
        this.changedistrict();
      }
      this.addpersonalinfo.subdistrict = taskchange.subdistrict;
      if (this.addpersonalinfo.subdistrict != null)
      {
        this.changesubdistrict();
      }
      this.addpersonalinfo.postalcode = taskchange.postalcode;
      // reportto search wathcer
      this.debouncedGetAnswer = _.debounce(this.getAnswer, 500);
    }
  },

  methods: {
    openDatePicker() {
      this.menu6 = true;
    },
    handlechange(selectedstatus) {
      if (selectedstatus == "Probation")
      {
        this.getProbationDay();
        this.change();
        this.disable_probationperiod = false;
        this.addpersonalinfo.probationdate = this.addpersonalinfo.probationdate;
      }
      else if (selectedstatus == "Permanent")
      {
        this.addpersonalinfo.probationperiod = 0;
        this.disable_probationperiod = true;
        this.addpersonalinfo.probationdate = this.addpersonalinfo.hiredate;
        this.change();
      }
      else if (selectedstatus == "Resign")
      {
        this.getProbationDay();
        this.addpersonalinfo.status = 2;
        this.disable_probationperiod = true;
        this.change();
      }
    },

    checkemployeestatus() {
      return this.disableall == false && this.disable_probationperiod == false;
    },

    getProbationDay() {
      let self = this;
      axios.get(`${self.url}Company/GetProbationByCompanyID?Company_ID=${store.state.companyID}`)
      .then(function (response)
      {
        self.probationList = response.data.data;
        self.addpersonalinfo.probationperiod = self.probationList[0].probation_Days;
        if (self.addpersonalinfo.probationperiod == null)
        {
          self.addpersonalinfo.probationperiod = 0;
        }
        else
        {
          return parseInt(self.addpersonalinfo.probationperiod);
        }
      });
    },

    changecropper(e) {
      if (this.showmycropper == true)
      {
        this.cropperSrc = e.canvas.toDataURL("image/png");
        this.showmycropper = false;
        this.cropDialog = false;
      }
    },

    Oncrop() {
      const { canvas } = this.$refs.cropper.getResult();
      if (canvas) {
        canvas.toBlob((blob) => {
          this.convertBackToImageFile(blob);
        });
      }
    },

    // convertBackToImageFile(imageBlob) {
    //   let self = this;
    //   const file = imageBlob;
    //   const reader = new FileReader();
    //   reader.readAsDataURL(file);
    //   reader.onload = () => {
    //     var arr = reader.result.split(","),
    //       mime = arr[1];
    //     self.imageUrl = mime;
    //     self.showmycropper = true;
    //     let temp = {
    //       image: self.imageUrl,
    //     };
    //     axios.post(`${self.url}ClockInOut/GetUrlFromImage`, temp)
    //     .then(response => {
    //       self.imageUrl = response.data.data; // Update the imageUrl with the file URL
    //       self.$refs.image.value = "";
    //       self.cropperSrc = self.imageUrl;
    //       console.log("imageURLfile", self.cropperSrc);
    //       self.beforecroppersrc = self.cropperSrc;
    //       self.showmycropper = true;
    //       console.log("imagefile", self.beforecroppersrc);
    //       self.$nextTick(() => {
    //         self.$refs.cropper.src = self.cropperSrc; // Update the src attribute of the cropper component
    //       });
    //     })
    //     .catch(error => {
    //       console.error("Error uploading the image:", error);
    //     });
    //   };
    // },
    convertBackToImageFile(imageBlob) {
      let self = this;
      const file = imageBlob;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let arr = reader.result.split(","),
          mime = arr[0],   // mime type (data:image/png;base64)
          data = arr[1];   // actual base64 encoded data
        self.imageUrl = data;
        self.$refs.image.value = "";
        self.cropperSrc = mime + "," + data;  // Correctly formatted Base64 URL
        self.beforecroppersrc = self.cropperSrc;
        self.showmycropper = true;
        self.$nextTick(() => {
          self.$refs.cropper.src = self.cropperSrc; // Update the src attribute of the cropper component
        });

        let temp = {
          image: self.imageUrl,  // Just the Base64 data part
        };
        axios.post(`${self.url}ClockInOut/GetUrlFromImage`, temp)
          .then(response => {
            self.imageUrl2 = response.data.data;
          })
          .catch(error => {
            console.error("Error uploading the image:", error);
          });
      };
    },

    SaveCroppedimage() {
      if (this.cropped == false)
      {
        this.Oncrop();
        this.showcrop = true;
        this.showmycropper = false;
        this.ss = false;
        this.showdefault = false;
        this.changepictrue = true;
        this.imageUrl1 = "";
      }
      else
      {
        this.ss = true;
        this.imageUrl1 = "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group 3166.png";
        this.cropDialog = false;
        this.beforecroppersrc = null;
      }
    },

    onFilePicked(e) {
      const files = e.target.files;
      var image = this.$refs.image;
      const imageWidth = image.naturalWidth;
      const imageHeight = image.naturalHeight;
      this.dynamicAspectRatio = imageWidth / imageHeight;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.cropperSrc = fr.result;
          this.cropDialog = true;
          this.cropped = false;
          this.$refs.image.value = "";
          this.showmycropper = false;
          localStorage.setItem("localprofile", this.imageUrl2);
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      }
    },

    EditCropimage() {
      this.cropDialog = true;
      if (this.showdefault == true) {
        this.cropperSrc = "data:image/png;base64," + this.mybase64img;
      }
      else {
        if (this.beforecroppersrc != null && this.beforecroppersrc != "") {
          this.cropperSrc ="data:image/png;base64," + this.imageUrl;
        }
      }
      this.isBase64Image = false;
    },

    DeletePhoto() {
      this.cropped = true;
      this.croppedimage = "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group 3166.png";
      this.Deleteconfirmdialog = false;
    },

    CancelCropdialog() {
      this.cropDialog = false;
      this.cropperSrc = null;
      this.$refs.imageincropper.value = '';
    },

    CancelCroppedimage() {
      if (!this.showdefault)
      {
        if (this.imageUrl1 != "")
        {
          this.cropped = true;
        }
        else
        {
          this.cropped = false;
        }
      }
      else
      {
        this.cropped = false;
      }
      this.cropDialog = false;
      this.$refs.image.value = "";
      this.$refs.imageincropper.value = "";
    },

    clearterminatedate() {
      let getstorage = JSON.parse(localStorage.getItem("gf"));
      this.addpersonalinfo.terminatedate = null;
      getstorage.terminatedate = this.addpersonalinfo.terminatedate;
      localStorage.setItem("gf", JSON.stringify(getstorage));
    },

    //permission
    disable_btn() {
      let self = this;
      if (self.$route.path == "/selfservice/PersonalProfile/PersonalInformation")
      {
        if (self.permission.add == false)
        {
          self.permission.add = false;
        }
        if (self.permission.edit == false)
        {
          self.permission.edit = false;
        }
      }
      else {
        if (self.permission_management.add == false)
        {
          self.permission_management.add = false;
        }
        if (self.permission_management.edit == false)
        {
          self.permission_management.edit = false;
        }
      }
    },

    // Get Employee name  for report to
    async GetReportTo() {
      let self = this;
      self.loadingdialog = true;
      await axios.get(`${self.url}Confirmemployee/GetConfirmEmployeeByCompanyID?Company_ID=${store.state.companyID}`)
      .then(function (response) {
        if(response.data.status == 0)
        {
          let temp = response.data.data;
          self.TempReportToList = temp;
          for (var i = 0; i < self.TempReportToList.length; i++)
          {
            if (self.TempReportToList[i].profile_Pic == null)
            {
              self.TempReportToList[i].profile_Pic = "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group%203166.png";
            }
          }
          self.TempReportToList.profile_Pic = "data:image/png;base64," + self.TempReportToList.profile_Pic;
          self.empCount = response.data.data.length;
        }
        self.loadingdialog = false;
      });
    },

    GetPersonal() {
      let self = this;
      let tempp = {
        company_ID: store.state.companyID,
      };
      axios.post(`${self.url}PersonalInfo/GetActiveEmployee`, tempp)
      .then(function (response) {
        self.Activeemplist = response.data.data;
        if (self.Activeemplist[0].package_ID != 0)
        {
          self.addpersonalinfo.PckgEmployeee = self.Activeemplist[0].activeEmp;
        }
        self.addpersonalinfo.Activeemployee = self.Activeemplist[0].currentactiveemp;
      });
    },

    // Search Employee for reportto
    async searchReport(input) {
      let self = this;
      function filterItems() {
        return self.TempReportToList.filter(function (el) {
          if (input)
          {
            if (el.employee_Name && el.employee_Code)
            {
              return (el.employee_Name.toLowerCase().indexOf(input.toLowerCase()) !== -1 || el.employee_Code.toString().toLowerCase().indexOf(input.toLowerCase()) !== -1);
            }
          }
          else
          {
            self.ReportToList = self.TempReportToList;
          }
        });
      }
      self.ReportToList = await filterItems();
    },

    // select employee for report to
    selectReportTo() {
      if (this.addpersonalinfo.employeecode !== this.addpersonalinfo.selected.emp_code)
      {
        if (this.addpersonalinfo.selected)
        {
          this.addpersonalinfo.ReportToEmployeeId = this.addpersonalinfo.selected.ID;
          this.addpersonalinfo.ReportToEmployeeName = this.addpersonalinfo.selected.Name;
          this.addpersonalinfo.ReportToEmployeeCode = this.addpersonalinfo.selected.emp_code;
          this.ReportDialog = false;
          let tem = {
            reportcode: this.addpersonalinfo.ReportToEmployeeCode,
            reportname: this.addpersonalinfo.ReportToEmployeeName,
            reportid: this.addpersonalinfo.ReportToEmployeeId,
          };
          localStorage.setItem("reportinfo", JSON.stringify(tem));
        }
      }
      else {
        alert("can't give reportTo id by himself/herself ");
      }
    },

    // show employee name for report to
    GetReportToPersonalData() {
      if (this.addpersonalinfo.ReportToEmployeeId) {
        let self = this;
        let temp = {
          employee_ID: parseInt(this.addpersonalinfo.ReportToEmployeeId),
          company_ID: store.state.companyID,
        };
        axios.post(`${self.url}PersonalInfo/GetShortInfo`, temp)
          .then(function (response) {
            self.addpersonalinfo.ReportToEmployeeName = response.data.data[0].name + " " + response.data.data[0].lastName;
            self.addpersonalinfo.ReportToEmployeeCode = response.data.data[0].employee_Code;
          });
      }
    },

    // Get department list when click
    GetDepartment() {
      let self = this;
      self.personaldepartmentlist = [];
      let temp = { company_ID: store.state.companyID };
      axios.post(`${self.url}Department/GetDepartmentsByCompanyID`, temp)
        .then(function (response) {
          self.departmentList = response.data.data;
          self.departmentList.map(function (data) {
            if (data.department_Name) {
              self.personaldepartmentlist.push(data.department_Name);
            }
          });
          self.personaldepartmentlist = [
            ...new Set(self.personaldepartmentlist),
          ];
        });
    },

    GetallDepartment() {
      let self = this;
      let temp = { company_ID: store.state.companyID };
      axios.post(`${self.url}Department/GetAllDepartmentsByCompanyID`, temp)
        .then(function (response) {
          self.departmentList = response.data.data;
          self.departmentList.map(function (data) {
            if (data.department_Name) {
              self.personaldepartmentlist.push(data.department_Name);
            }
          });
          self.personaldepartmentlist = [
            ...new Set(self.personaldepartmentlist),
          ];
        });
    },

    // Get division list by department name
    changedepartment(temp) {
      let self = this;
      self.divisionlist = [];
      self.sectionlist = [];
      let mytemp = {
        department_Name: temp,
        company_ID: store.state.companyID,
      };
      axios.post(`${self.url}Department/GetDivBydepname`, mytemp)
        .then(function (response) {
          response.data.data.map(function (data) {
            if (data.division_Name) {
              if (data.department_Name === temp) {
                self.divisionlist.push(data.division_Name);
              }
            }
          });
          self.divisionlist = [...new Set(self.divisionlist)];
        });
    },

    clickdiv(temp) {
      let self = this;
      self.divisionlist = [];
      self.sectionlist = [];
      let mytemp = {
        department_Name: temp,
        company_ID: store.state.companyID,
      };
      axios.post(`${self.url}Department/GetDivBydepnameforactive`, mytemp)
      .then(function (response) {
        if( response.data.status == 0)
        {
          response.data.data.map(function (data) {
            if (data.division_Name)
            {
              self.divisionlist.push(data.division_Name);
            }
          });
          self.divisionlist = [...new Set(self.divisionlist)]; 
        }
      });
    },

    // get section list by divison name
    changedivision(temp) {
      let self = this;
      self.sectionlist = [];
      let mytemp = {
        department_Name: self.addpersonalinfo.department,
        division_Name: temp,
        company_ID: store.state.companyID,
      };
      axios.post(`${self.url}Department/GetsectionBydep`, mytemp)
        .then(function (response) {
          self.sectionlist = response.data.data;
        });
    },

    changedivisionforsection() {
      let self = this;
      self.sectionlist = [];
      let mytemp = {
        department_Name: self.addpersonalinfo.department,
        division_Name: self.addpersonalinfo.division,
        company_ID: store.state.companyID,
      };
      axios.post(`${self.url}Department/GetsectionBydepforactive`, mytemp)
        .then(function (response) {
          self.sectionlist = response.data.data;
        });
    },

    // for show and hide edit and save buttons
    showandhide() {
      if (this.$route.path == "/selfservice/PersonalProfile/PersonalInformation") {
        this.showbysid = true;
        this.showbyid = false;
        this.showsave = false;
        this.showedit = false;
        this.disableall = false;
        this.disable_probationperiod = false;
        this.showbycode = false;
        if (this.addpersonalinfo.foreignemployee == false)
        {
          this.disablepersonalID = false;
        }
        let showforprofile = true;
        localStorage.setItem("showforpersonalprofile", showforprofile);
      }
      else if (this.$route.params.id != null)
      {
        this.showbysid = false;
        this.showbyid = true;
        this.showsave = false;
        this.showedit = false;
        this.disable_probationperiod = false;
        this.disableall = false;
        if (this.addpersonalinfo.foreignemployee == false)
        {
          this.disablepersonalID = false;
        }
        this.showbycode = false;
        localStorage.setItem("showforeditpersonal", this.showbyid);
      }
      else
      {
        this.showbysid = false;
        this.showbyid = false;
        this.showsave = false;
        this.showedit = false;
        this.disableall = false;
        this.disable_probationperiod = false;
        if (this.addpersonalinfo.foreignemployee == false)
        {
          this.disablepersonalID = false;
        }
        this.showbycode = true;
        localStorage.setItem("showforeditpersonalprofile", this.showbycode);
      }
      localStorage.setItem("mydisable", this.disableall);
    },

    hidethis() {
      //this.hideandshow = false;
      this.showbysid = false;
      this.showbyid = false;
      this.showsave = false;
      this.showedit = true;
      this.disableall = true;
      // this.disablepersonalID
      this.showbycode = false;
      localStorage.mydisable = true;
      localStorage.showforeditpersonal = false;
      if (localStorage.showforpersonalprofile != undefined) {
        let showforprofile = false;
        localStorage.setItem("showforpersonalprofile", showforprofile);
      }
      else {
        localStorage.showforpersonalprofile = false;
      }
      localStorage.removeItem("gf");
      localStorage.removeItem("gg");
      localStorage.removeItem("mydisable");
      localStorage.removeItem("showforpersonalprofile");
      localStorage.removeItem("showforeditpersonal");
      localStorage.removeItem("showforeditpersonalprofile");
      localStorage.removeItem("localprofile");
      localStorage.removeItem("empcode");
      localStorage.removeItem("reportinfo");
      localStorage.removeItem("ww");
      localStorage.removeItem("ii");
      localStorage.removeItem("localworkpermitUrl");
      localStorage.removeItem("workpermitname");
      localStorage.removeItem("localworkeditpermitUrl");
      localStorage.removeItem("editworkpermitname");
      localStorage.removeItem("LocalPersonalidUrl");
      localStorage.removeItem("filename");
      localStorage.removeItem("LocaleditPersonalidUrl");
      localStorage.removeItem("get_date_of_today_return");
      localStorage.removeItem("get_date_of_today_return1");
      localStorage.removeItem("editfilename");
      localStorage.removeItem("localotherinfoUrl");
      localStorage.removeItem("othername");
      localStorage.removeItem("localeditotherinfoUrl");
      localStorage.removeItem("editothername");
      localStorage.removeItem("localPassportUrl");
      localStorage.removeItem("passportname");
      localStorage.removeItem("localeditPassportUrl");
      localStorage.removeItem("editpassportname");
      localStorage.removeItem("UserEditUserGp");
      localStorage.removeItem("TempUserGroup");
      localStorage.removeItem("UserEditRole");
      localStorage.removeItem("TempRole");
      localStorage.removeItem("UserEditRole");
      localStorage.removeItem("UserEditPer");
      this.GetAllPosition();
      this.GetallDepartment();
      this.getpersonalinfo();
    },

    // validate telephone number
    telephonenumbervalidation(tele) {
      let teleph = /^\d{9}$/;
      if (teleph.test(tele)) {
        return true;
      }
      else {
        return "Invalid Telephone number format";
      }
    },

    // validate tax number
    taxvalidation(tax) {
      if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
        let taxpay = /^\d{13}$/;
        if (taxpay.test(tax)) {
          return true;
        }
        else {
          return "Invalid Tax format";
        }
      }
      else {
        return true;
      }
    },

    Activeempvalidation() { },

    // validate mobile number
    mobilenumbervalidation(mobil) {
      let phoneno1 = /^\d{10}$/;
      let phoneno2 = /^\d{11}$/;
      let phoneno3 = /^\d{9}$/;
      if (phoneno1.test(mobil) || phoneno2.test(mobil) || phoneno3.test(mobil)) {
        return true;
      }
      else {
        return "Invalid Mobile format";
      }
    },

    // validate passport
    passportvalidation(income) {
      let field = income;
      if (field.length >= 6 && field.length <= 9) {
        return true;
      }
      else {
        return "Invalid Passport format";
      }
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },

    onlyNumberforpersonalandtax($event) {
      if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
          $event.preventDefault();
        }
      }
    },

    // Get age by date of birth
    getAge(dateString) {
      if (dateString != "" && dateString != null) {
        this.error.errormessageage = "";
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        this.addpersonalinfo.age = age;
        localStorage.setItem("ww", this.addpersonalinfo.DOB);
        localStorage.setItem("ii", this.addpersonalinfo.age);
      }

    },

    // store all textfields in local storage
    keymonitor: function () {
      let textother = this.otherimagename;
      localStorage.setItem("fortext", textother);
      let tem = {
        employeecode: this.addpersonalinfo.employeecode,
        prefix: this.addpersonalinfo.prefix,
        firstname: this.addpersonalinfo.firstname,
        lastname: this.addpersonalinfo.lastname,
        nickname: this.addpersonalinfo.nickname,
        age: this.addpersonalinfo.age,
        taxid: this.addpersonalinfo.taxpayerID,
        personalid: this.addpersonalinfo.personalID_Number,
        workpermitname: this.workpermitname,
        passport: this.passport,
        probationperiod: this.addpersonalinfo.probationperiod,
        house: this.addpersonalinfo.housenumber,
        tele: this.addpersonalinfo.telephonenum,
        mobile: this.addpersonalinfo.mobile_number,
        email: this.addpersonalinfo.email,
        personalID_Number: this.addpersonalinfo.personalID_Number,
        reportcode: this.addpersonalinfo.ReportToEmployeeCode,
        reportname: this.addpersonalinfo.ReportToEmployeeName,
        reportid: this.addpersonalinfo.ReportToEmployeeId,
      };
      localStorage.setItem("gg", JSON.stringify(tem));
    },

    // store all select box in local storage
    change() {
      if (this.addpersonalinfo.hiredate != "" && this.addpersonalinfo.hiredate != null && this.addpersonalinfo.probationperiod) {
        let yy = this.addpersonalinfo.hiredate;
        if (yy.includes("T")) {
          yy = yy.split("T")[0];
        }
        var mydate = yy.split("-")[2];
        var myyear = yy.split("-")[0];
        var mymonth = yy.split("-")[1];
        var mymonth1 = mymonth - 1;
        var addday = parseInt(this.addpersonalinfo.probationperiod);
        var somedate = new Date(myyear, mymonth1, mydate);
        var myNewDate = new Date(somedate);
        myNewDate.setDate(myNewDate.getDate() + addday);
        var year1 = myNewDate.getFullYear();
        var month1 = myNewDate.getMonth();
        var date1 = myNewDate.getDate();
        if (month1 == 0) {
          month1 = 1;
        }
        else if (month1 > 0) {
          month1 += 1;
        }
        if (date1 < 10) {
          date1 = 0 + date1.toString();
        }
        if (month1 < 10) {
          month1 = 0 + month1.toString();
        }
        this.addpersonalinfo.probationdate = year1 + "-" + month1 + "-" + date1;
        // this.addpersonalinfo.probationdate=this.formatDate(this.addpersonalinfo.probationdate);
      }
      else if (this.addpersonalinfo.probationperiod == 0) {
        this.addpersonalinfo.probationdate = this.addpersonalinfo.hiredate;
      }
      let tempchange = {
        gender: this.addpersonalinfo.gender,
        religion: this.addpersonalinfo.religion,
        foreignemployee: this.addpersonalinfo.foreignemployee,
        DOB: this.addpersonalinfo.DOB,
        status: this.addpersonalinfo.martialstatus,
        expireddate: this.addpersonalinfo.expired_date,
        workpermitexpire: this.addpersonalinfo.workpermitexpiredate,
        passsportexpire: this.addpersonalinfo.passportexpiredate,
        employeetype: this.addpersonalinfo.employeetype,
        hireddate: this.addpersonalinfo.hiredate,
        probationdate: this.addpersonalinfo.probationdate,
        department: this.addpersonalinfo.department,
        division: this.addpersonalinfo.division,
        section: this.addpersonalinfo.section,
        position: this.addpersonalinfo.position,
        level: this.addpersonalinfo.level,
        terminatedate: this.addpersonalinfo.terminatedate,
        terminateeffectdate: this.addpersonalinfo.terminateeffectdate,
        workdaycalendar: this.addpersonalinfo.calendartype,
        shiftcode: this.addpersonalinfo.shiftcode,
        empstatus: this.addpersonalinfo.status,
        subdistrict: this.addpersonalinfo.subdistrict,
        district: this.addpersonalinfo.district,
        province: this.addpersonalinfo.province,
        country: this.addpersonalinfo.country,
        postalcode: this.addpersonalinfo.postalcode,
        personalID_Number: this.addpersonalinfo.personalID_Number,
        workpermitname: this.workpermitname,
        passport: this.passport,
        employeestatus: this.addpersonalinfo.employeestatus,
      };
      if(this.addpersonalinfo.status == 2){
        this.inactivestatus = true;
      }else{
        this.inactivestatus = false;
      }
      localStorage.setItem("gf", JSON.stringify(tempchange));
    },

    // get provincelist by country name
    changecountry() {
      let self = this;
      let temp = {
        country_ID: this.addpersonalinfo.country,
        company_ID: store.state.companyID,
      };
      axios.post(`${self.url}Province/GetProvincebyCountry`, temp)
        .then(function (response) {
          self.ProvinceList = response.data.data;
          self.ProvinceList.sort((a, b) =>
            a.province_Name > b.province_Name ? 1 : -1
          );
        });
    },

    // get district list by province name
    changeprovince() {
      let self = this;
      if (self.addpersonalinfo.province != "") {
        let temp = {
          company_ID: store.state.companyID,
          province_ID: this.addpersonalinfo.province,
        };
        axios.post(`${self.url}District/GetDistrictWithProvince`, temp)
          .then(function (response) {
            self.Districtlist = response.data.data;
            self.Districtlist.sort((a, b) =>
              a.district_Name > b.district_Name ? 1 : -1
            );
          });
      }
    },

    // get sub district and postal code by district name
    changedistrict() {
      let self = this;
      if (self.addpersonalinfo.district != "") {
        let temp = {
          company_ID: store.state.companyID,
          district_ID: this.addpersonalinfo.district,
        };
        axios.post(`${self.url}Sub_District/GetSubDistrictWithDistrict`, temp)
          .then(function (response) {
            self.Subdistrictlist = response.data.data;
            self.Subdistrictlist.sort((a, b) =>
              a.sub_District_Name > b.sub_District_Name ? 1 : -1
            );
          });
      }
    },

    changesubdistrict() {
      let self = this;
      if (self.addpersonalinfo.subdistrict != "") {
        let temp = {
          company_ID: store.state.companyID,
          sub_District_ID: this.addpersonalinfo.subdistrict,
        };
        axios.post(`${self.url}PostalCode/GetPostalCodeWithSubDistrict`, temp)
          .then(function (response) {
            self.Postalcodelist = response.data.data;
          });
      }
    },

    onPickFile() {
      this.beforecroppersrc = null;
      this.$refs.image.click();
    },

    onpickchangephoto() {
      //  this.beforecroppersrc=null;
      this.$refs.imageincropper.click();
    },

    OnpickPersonalID() {
      this.$refs.image1.click();
    },

    OnpickPassport() {
      this.$refs.image2.click();
    },

    onFilePicked1(e) {
      this.files = e.target.files;
      this.imageName1 = e.target.files[0].name;
    },

    onFilePicked2(e) {
      this.files1 = e.target.files;
      this.imageName2 = e.target.files[0].name;
    },

    goeducation() {
      let empID = this.addpersonalinfo.employeecode;
      if (this.$route.path == "/selfservice/PersonalProfile/PersonalInformation") {
        let myid = "";
        if (this.addpersonalinfo.employeecode != "" && this.addpersonalinfo.employeecode != null) {
          myid = this.addpersonalinfo.employeecode;
        }
        else {
          myid = "0";
        }
        this.$router.push({ name: "PersonalEducationBackground", params: { eduid: myid } }).catch(() => { });
      }
      else if (this.$route.path == "/PersonnelManagement/NewEmployee/NewPersonalInformation") {
        this.$router.push({ name: "neweducationbackground" }).catch(() => { });
      }
      else {
        this.$router.push({ name: "editEducational", params: { id: this.$route.params.id, eduid: empID } }).catch(() => { });
      }
    },

    // direct to other info page
    goother() {
      let other = this.$route.params.id;
      if (this.$route.path == "/selfservice/PersonalProfile/PersonalInformation") {
        this.$router.push({ name: "PersonalOtherInfo" }).catch(() => { });
      }
      else if (this.$route.path == "/PersonnelManagement/NewEmployee/NewPersonalInformation") {
        this.$router.push({ name: "newotherinformation" }).catch(() => { });
      }
      else if (other != "undefined") {
        this.$router.push({ name: "otherinformation1", params: { id: this.$route.params.id, otherid: other } }).catch(() => { });
      }
    },

    // direct to passport page
    gopassport() {
      let pass = this.$route.params.id;
      if (this.$route.path == "/selfservice/PersonalProfile/PersonalInformation") {
        this.$router.push({ name: "PersonalPassport" }).catch(() => { });
      }
      else if (this.$route.path == "/PersonnelManagement/NewEmployee/NewPersonalInformation") {
        this.$router.push({ name: "newpassport" }).catch(() => { });
      }
      else if (pass != "undefined") {
        this.$router.push({ name: "passport1", params: { id: this.$route.params.id, passportid: pass } }).catch(() => { });
      }
    },

    // direct to personal in number
    gopersonalid() {
      let personal = this.$route.params.id;
      if (this.$route.path == "/selfservice/PersonalProfile/PersonalInformation") {
        this.$router.push({ name: "PersonalInfoID" }).catch(() => { });
      }
      else if (this.$route.path == "/PersonnelManagement/NewEmployee/NewPersonalInformation") {
        this.$router.push({ name: "newpersonalid" }).catch(() => { });
      }
      else if (personal != "undefined") {
        this.$router.push({ name: "personalid1", params: { id: this.$route.params.id, personalid: personal } }).catch(() => { });
      }
    },

    // direct to department transfer
    departmenttransfer() {
      let personal = this.$route.params.id;
      if (this.$route.path == "/selfservice/PersonalProfile/PersonalInformation") {
        this.$router.push({ name: "PersonalDepartmentTransferr1", params: { personalid: store.state.employeeID } }).catch(() => { });
      }
      else if (this.$route.path == "/PersonnelManagement/NewEmployee/NewPersonalInformation") {
        this.$router.push({ name: "newdepartmenttransferr" }).catch(() => { });
      }
      else if (personal != "undefined") {
        this.$router.push({ name: "departmenttransfer", params: { id: this.$route.params.id, personalid: personal } }).catch(() => { });
      }
    },

    // direct to work permit page
    goworkpermit() {
      let workper = this.$route.params.id;
      if (this.$route.path == "/selfservice/PersonalProfile/PersonalInformation") {
        this.$router.push({ name: "PersonalInfoWorkPermit" }).catch(() => { });
      }
      else if (this.$route.path == "/PersonnelManagement/NewEmployee/NewPersonalInformation") {
        this.$router.push({ name: "newworkpermit" }).catch(() => { });
      }
      else if (workper != "undefined") {
        this.$router.push({ name: "workpermit1", params: { id: this.$route.params.id, workid: workper } }).catch(() => { });
      }
    },

    // Get personal information
    getpersonalinfo() {
      let self = this;
      self.addpersonalinfo.Activeemployee = 0;
      self.loadingdialog = true;
      let fortask1 = JSON.parse(localStorage.getItem("gg"));
      let fortask2 = JSON.parse(localStorage.getItem("gf"));
      let fortask3 = JSON.parse(localStorage.getItem("reportinfo"));
      this.workimgsend = self.$route.params.id;
      localStorage.setItem("localwork", this.workimgsend);
      if (self.$route.path == "/selfservice/PersonalProfile/PersonalInformation")
      {
        let temp = {
          employee_ID: parseInt(store.state.employeeID),
          company_ID: store.state.companyID,
        };
        axios.post(`${self.url}PersonalInfo/GetPersonalInfo`, temp)
          .then(function (response) {
            if (response.data.status == 0)
            {
              self.PersonalList = response.data.data;
              if (self.addpersonalinfo.shiftcode == null || self.addpersonalinfo.shiftcode == "" || self.addpersonalinfo.shiftcode == 0) {
                self.addpersonalinfo.shiftcode = self.DefaultShiftCode.shift_ID;
              }
              self.mybase64img = self.PersonalList[0].profileimageBase64;
              self.loadingdialog = false;
              if (self.PersonalList.length != 0) {
                self.disableall = true;
                self.addpersonalinfo.Activeemployee = self.PersonalList[0].activeemp;
                if (localStorage.showforpersonalprofile == "true") {
                  self.showbysid = true;
                  self.showedit = false;
                  self.disablepersonalID = false;
                }
                else {
                  self.showbysid = false;
                  self.showedit = true;
                  self.disablepersonalID = true;
                }
                if (fortask1 == null) {
                  self.addpersonalinfo.employeecode = self.PersonalList[0].employee_Code;
                  self.addpersonalinfo.prefix = self.PersonalList[0].prefix;
                  self.addpersonalinfo.firstname = self.PersonalList[0].name;
                  self.addpersonalinfo.lastname = self.PersonalList[0].lastName;
                  self.addpersonalinfo.nickname = self.PersonalList[0].nickname;
                  self.addpersonalinfo.taxpayerID = self.PersonalList[0].taxpayerID;
                  if (self.PersonalList[0].probation_Period != null) {
                    self.addpersonalinfo.probationperiod = self.PersonalList[0].probation_Period;
                  }
                  else {
                    self.addpersonalinfo.probationperiod = 119;
                  }
                  self.addpersonalinfo.housenumber = self.PersonalList[0].houseNumber;
                  self.addpersonalinfo.telephonenum = self.PersonalList[0].telephone;
                  self.addpersonalinfo.mobile_number = self.PersonalList[0].mobile;
                  self.addpersonalinfo.email = self.PersonalList[0].email;
                  self.workpermitname = self.PersonalList[0].work_Permit;
                  self.passport = self.PersonalList[0].passport;
                  self.addpersonalinfo.personalID_Number = self.PersonalList[0].personalID_Number;
                  self.addpersonalinfo.ReportToEmployeeId = self.PersonalList[0].report_ID;
                }
                else {
                  self.addpersonalinfo.employeecode = fortask1.employeecode;
                  self.addpersonalinfo.prefix = fortask1.prefix;
                  self.addpersonalinfo.firstname = fortask1.firstname;
                  self.addpersonalinfo.lastname = fortask1.lastname;
                  self.addpersonalinfo.nickname = fortask1.nickname;
                  self.addpersonalinfo.taxpayerID = fortask1.taxid;
                  self.addpersonalinfo.probationperiod = fortask1.probationperiod;
                  self.addpersonalinfo.housenumber = fortask1.house;
                  self.addpersonalinfo.telephonenum = fortask1.tele;
                  self.addpersonalinfo.mobile_number = fortask1.mobile;
                  self.addpersonalinfo.email = fortask1.email;
                  self.addpersonalinfo.personalID_Number = fortask1.personalID_Number;
                  self.workpermitname = fortask1.workpermitname;
                  self.passport = fortask1.passport;
                }
                if (fortask2 == null) {
                  self.addpersonalinfo.gender = self.PersonalList[0].gender;
                  self.addpersonalinfo.religion = self.PersonalList[0].religion;
                  self.addpersonalinfo.DOB = self.PersonalList[0].birthDate;
                  self.addpersonalinfo.age = self.PersonalList[0].age;
                  self.addpersonalinfo.ReportToEmployeeId = self.PersonalList[0].report_ID;
                  self.addpersonalinfo.martialstatus = self.PersonalList[0].status;
                  self.addpersonalinfo.expired_date = self.PersonalList[0].expiredDate;
                  self.addpersonalinfo.foreignemployee = self.PersonalList[0].foreign_Employee;
                  self.addpersonalinfo.employeetype = self.PersonalList[0].employeeType;
                  self.addpersonalinfo.hiredate = self.PersonalList[0].hiredDate;
                  self.addpersonalinfo.probationdate = self.PersonalList[0].probationDate;
                  self.addpersonalinfo.department = self.PersonalList[0].departmentName;
                  self.changedepartment(self.addpersonalinfo.department);
                  self.addpersonalinfo.division = self.PersonalList[0].divisionName;
                  self.changedivision(self.addpersonalinfo.division);
                  self.addpersonalinfo.section = self.PersonalList[0].section_ID;
                  self.addpersonalinfo.position = self.PersonalList[0].positionID;
                  self.addpersonalinfo.supervisorname = self.PersonalList[0].report_ID;
                  self.addpersonalinfo.level = self.PersonalList[0].level;
                  self.addpersonalinfo.terminatedate = self.PersonalList[0].terminateDate;
                  self.addpersonalinfo.status = self.PersonalList[0].employeeStatus;
                  self.addpersonalinfo.terminateeffectdate = self.PersonalList[0].terminateEffectiveDate;
                  self.addpersonalinfo.calendartype = self.PersonalList[0].workday_Calendar;
                  self.addpersonalinfo.shiftcode = self.PersonalList[0].shift_ID;
                  //self.DefaultShiftCode=  
                  self.addpersonalinfo.country = self.PersonalList[0].country_ID;
                  self.changecountry();
                  self.addpersonalinfo.province = self.PersonalList[0].province_ID;
                  self.changeprovince();
                  self.addpersonalinfo.district = self.PersonalList[0].district_ID;
                  self.changedistrict();
                  self.addpersonalinfo.subdistrict = self.PersonalList[0].sub_District_ID;
                  self.changesubdistrict();
                  self.addpersonalinfo.postalcode = parseInt(self.PersonalList[0].postal_Code);
                }
                else {
                  self.addpersonalinfo.gender = fortask2.gender;
                  self.addpersonalinfo.foreignemployee = fortask2.foreignemployee;
                  self.addpersonalinfo.religion = fortask2.religion;
                  self.addpersonalinfo.DOB = fortask2.DOB;
                  if (self.addpersonalinfo.DOB != "") {
                    self.getAge(self.addpersonalinfo.DOB);
                  }
                  self.addpersonalinfo.martialstatus = fortask2.status;
                  self.addpersonalinfo.expired_date = fortask2.expireddate;
                  self.addpersonalinfo.workpermitexpiredate = fortask2.workpermitexpire;
                  self.addpersonalinfo.passportexpiredate = fortask2.passsportexpire;
                  self.addpersonalinfo.employeetype = fortask2.employeetype;
                  self.addpersonalinfo.hiredate = fortask2.hireddate;
                  self.addpersonalinfo.probationdate = fortask2.probationdate;
                  self.addpersonalinfo.department = fortask2.department;
                  self.changedepartment(self.addpersonalinfo.department);
                  self.addpersonalinfo.division = fortask2.division;
                  self.changedivision(self.addpersonalinfo.division);
                  self.addpersonalinfo.section = fortask2.section;
                  self.addpersonalinfo.sectionID = self.PersonalList[0].section_ID;
                  self.addpersonalinfo.divisonID = self.PersonalList[0].divisionID;
                  self.addpersonalinfo.position = fortask2.position;
                  self.addpersonalinfo.level = fortask2.level;
                  self.addpersonalinfo.terminatedate = fortask2.terminatedate;
                  self.addpersonalinfo.terminateeffectdate = fortask2.terminateeffectdate;
                  self.addpersonalinfo.calendartype = fortask2.workdaycalendar;
                  self.addpersonalinfo.shiftcode = fortask2.shiftcode;
                  self.addpersonalinfo.status = fortask2.empstatus;
                  self.addpersonalinfo.postalcode = fortask2.postalcode;
                }
                if (self.addpersonalinfo.terminatedate != null || self.addpersonalinfo.terminatedate != "") {
                  var getdate = moment(self.addpersonalinfo.terminatedate, "YYYY-MM-DD");
                  var tdydate = moment();
                  if (tdydate >= getdate) {
                    self.addpersonalinfo.status = 2;
                  }
                  else {
                    self.addpersonalinfo.status = 1;
                  }
                }
                if (self.addpersonalinfo.foreignemployee == true) {
                  self.disablepersonalID = true;
                }
                if (fortask3 == null) {
                  self.addpersonalinfo.ReportToEmployeeId = self.PersonalList[0].report_ID;
                }
                else {
                  self.addpersonalinfo.ReportToEmployeeId = fortask3.reportid;
                  self.addpersonalinfo.ReportToEmployeeName = fortask3.reportname;
                  self.addpersonalinfo.ReportToEmployeeCode = fortask3.reportcode;
                }
                if (localStorage.workpermitname == null) {
                  self.workpermitUrl = self.PersonalList[0].work_Permit_Image;
                }
                if (localStorage.othername == null) {
                  self.otherimagename = self.PersonalList[0].other_Information;
                  self.otherinfoUrl = self.PersonalList[0].driver_Licence;
                  if (self.PersonalList[0].other_Information == "undefined" || self.PersonalList[0].other_Information == undefined) {
                    self.otherinfomation = "Other Information";
                    self.otherimagename = "Other Information";
                  }
                  else {
                    self.otherinfomation = self.PersonalList[0].other_Information;
                    self.otherimagename = self.PersonalList[0].other_Information;
                    self.showthis = false;
                  }
                }
                else {
                  self.otherimagename = localStorage.fortext;
                }
                if (localStorage.passportname == null) {
                  self.passportUrl = self.PersonalList[0].passport_Image;
                }
                if (self.PersonalList[0].personalID != null) {
                  self.personalIdUrl = self.PersonalList[0].personalID;
                  self.myimage = self.PersonalList[0].personalID;
                }
                else {
                  self.myimage = localStorage.filename;
                }
                self.addpersonalinfo.workpermitexpiredate = self.PersonalList[0].work_Permit_Expired_Date;
                self.addpersonalinfo.passportexpiredate = self.PersonalList[0].passport_Expired_Date;
                self.imageUrl1 = self.PersonalList[0].image ? self.PersonalList[0].image : "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group 3166.png";
                if (self.imageUrl1 == "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group 3166.png") {
                  self.changepictrue = false;
                }
                else {
                  self.changepictrue = true;
                }
                sessionStorage.setItem("profileimage", self.imageUrl1);
                store.state.profileimage = sessionStorage.getItem("profileimage");
                let tempedit = {
                  personalid: self.PersonalList[0].personalID,
                  workpermit: self.PersonalList[0].work_Permit_Image,
                  otherimage: self.PersonalList[0].driver_Licence,
                  passport: self.PersonalList[0].passport_Image,
                };
                // self.showedit = true;
                self.disableall = self.showedit;
                localStorage.setItem("edit", JSON.stringify(tempedit));
                self.GetReportToPersonalData();
                //self.LogTrace(null, "Get Personal Information", 14, "Critical");
              }
              else {
                if (localStorage.showforpersonalprofile != undefined) {
                  if (localStorage.showforpersonalprofile == "true")
                  {
                    self.showbysid = true;
                    self.showedit = false;
                    self.disablepersonalID = false;
                  }
                  else {
                    self.showbysid = false;
                    self.showedit = true;
                    self.disablepersonalID = true;
                  }
                }
                else {
                  self.showbysid = true;
                  self.showedit = false;
                }
                self.disableall = self.showedit;
                if (fortask1 != null)
                {
                  self.addpersonalinfo.employeecode = fortask1.employeecode;
                  self.addpersonalinfo.firstname = fortask1.firstname;
                  self.addpersonalinfo.lastname = fortask1.lastname;
                  self.addpersonalinfo.nickname = fortask1.nickname;
                  self.addpersonalinfo.taxpayerID = fortask1.taxid;
                  self.addpersonalinfo.probationperiod = fortask1.probationperiod;
                  self.addpersonalinfo.housenumber = fortask1.house;
                  self.addpersonalinfo.telephonenum = fortask1.tele;
                  self.addpersonalinfo.mobile_number = fortask1.mobile;
                  self.addpersonalinfo.email = fortask1.email;
                  self.addpersonalinfo.personalID_Number = fortask1.personalID_Number;
                  self.workpermitname = fortask1.workpermitname;
                  self.passport = fortask1.passport;
                }
                if (fortask2 != null)
                {
                  self.addpersonalinfo.gender = fortask2.gender;
                  self.addpersonalinfo.foreignemployee = fortask2.foreignemployee;
                  self.addpersonalinfo.religion = fortask2.religion;
                  self.addpersonalinfo.DOB = fortask2.DOB;
                  if (self.addpersonalinfo.DOB != "")
                  {
                    self.getAge(self.addpersonalinfo.DOB);
                  }
                  self.addpersonalinfo.martialstatus = fortask2.status;
                  self.addpersonalinfo.expired_date = fortask2.expireddate;
                  self.addpersonalinfo.workpermitexpiredate = fortask2.workpermitexpire;
                  self.addpersonalinfo.passportexpiredate = fortask2.passsportexpire;
                  self.addpersonalinfo.employeetype = fortask2.employeetype;
                  self.addpersonalinfo.hiredate = fortask2.hireddate;
                  self.addpersonalinfo.probationdate = fortask2.probationdate;
                  self.addpersonalinfo.department = fortask2.department;
                  if (self.addpersonalinfo.department != "")
                  {
                    self.changedepartment(self.addpersonalinfo.department);
                  }
                  self.addpersonalinfo.division = fortask2.division;
                  if (self.addpersonalinfo.division != "")
                  {
                    self.changedivision(self.addpersonalinfo.division);
                  }
                  self.addpersonalinfo.section = fortask2.section;
                  self.addpersonalinfo.position = fortask2.position;
                  self.addpersonalinfo.level = fortask2.level;
                  self.addpersonalinfo.terminatedate = fortask2.terminatedate;
                  self.addpersonalinfo.terminateeffectdate = fortask2.terminateeffectdate;
                  self.addpersonalinfo.calendartype = fortask2.workdaycalendar;
                  self.addpersonalinfo.shiftcode = fortask2.shiftcode;
                  self.addpersonalinfo.status = fortask2.empstatus;
                  self.addpersonalinfo.postalcode = fortask2.postalcode;
                }
                if (self.addpersonalinfo.foreignemployee == true)
                {
                  self.disablepersonalID = true;
                }
                if (fortask3 != null)
                {
                  self.addpersonalinfo.ReportToEmployeeId = fortask3.reportid;
                  self.addpersonalinfo.ReportToEmployeeName = fortask3.reportname;
                  self.addpersonalinfo.ReportToEmployeeCode = fortask3.reportcode;
                }
                if (localStorage.othername != null) {
                  self.otherimagename = localStorage.fortext;
                }
              }
            }
          })
          .catch(function (error) {
            self.LogTrace(error, "Get Personal Information Fail", 14, "Critical");
            self.loadingdialog = false;
          });
      }
      else if (self.$route.params.id != null)
      {
        let temp = {
          employee_ID: parseInt(self.$route.params.id),
          company_ID: store.state.companyID,
        };
        axios.post(`${self.url}PersonalInfo/GetPersonalInfo`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.PersonalList = response.data.data;
              self.addpersonalinfo.Activeemployee = self.PersonalList[0].activeemp;
              self.mybase64img = self.PersonalList[0].profileimageBase64;
              self.loadingdialog = false;
              if (localStorage.mydisable == "false") {
                self.disableall = false;
                self.disablepersonalID = false;
              }
              else {
                self.disableall = true;
                self.disablepersonalID = true;
              }
              if (fortask1 == null) {
                self.addpersonalinfo.employeecode = self.PersonalList[0].employee_Code;
                self.addpersonalinfo.prefix = self.PersonalList[0].prefix;
                self.addpersonalinfo.firstname = self.PersonalList[0].name;
                self.addpersonalinfo.lastname = self.PersonalList[0].lastName;
                self.addpersonalinfo.nickname = self.PersonalList[0].nickname;
                self.addpersonalinfo.taxpayerID = self.PersonalList[0].taxpayerID;
                if (self.PersonalList[0].probation_Period != null) {
                  self.addpersonalinfo.probationperiod = self.PersonalList[0].probation_Period;
                }
                else {
                  self.addpersonalinfo.probationperiod = 119;
                }
                self.addpersonalinfo.housenumber = self.PersonalList[0].houseNumber;
                self.addpersonalinfo.telephonenum = self.PersonalList[0].telephone;
                self.addpersonalinfo.mobile_number = self.PersonalList[0].mobile;
                self.addpersonalinfo.email = self.PersonalList[0].email;
                self.addpersonalinfo.personalID_Number = self.PersonalList[0].personalID_Number;
                self.addpersonalinfo.ReportToEmployeeId = self.PersonalList[0].report_ID;
                self.passport = self.PersonalList[0].passport;
                self.workpermitname = self.PersonalList[0].work_Permit;
              }
              else {
                self.addpersonalinfo.employeecode = fortask1.employeecode;
                self.addpersonalinfo.prefix = fortask1.prefix;
                self.addpersonalinfo.firstname = fortask1.firstname;
                self.addpersonalinfo.lastname = fortask1.lastname;
                self.addpersonalinfo.nickname = fortask1.nickname;
                self.addpersonalinfo.taxpayerID = fortask1.taxid;
                self.addpersonalinfo.probationperiod = fortask1.probationperiod;
                self.addpersonalinfo.housenumber = fortask1.house;
                self.addpersonalinfo.telephonenum = fortask1.tele;
                self.addpersonalinfo.mobile_number = fortask1.mobile;
                self.addpersonalinfo.email = fortask1.email;
                self.addpersonalinfo.personalID_Number = fortask1.personalID_Number;
                self.passport = fortask1.passport;
                self.workpermitname = fortask1.workpermitname;
              }
              if (fortask2 == null)
              {
                self.addpersonalinfo.gender = self.PersonalList[0].gender;
                self.addpersonalinfo.religion = self.PersonalList[0].religion;
                self.addpersonalinfo.DOB = self.PersonalList[0].birthDate;
                self.addpersonalinfo.age = self.PersonalList[0].age;
                self.addpersonalinfo.ReportToEmployeeId = self.PersonalList[0].report_ID;
                self.addpersonalinfo.martialstatus = self.PersonalList[0].status;
                self.addpersonalinfo.expired_date = self.PersonalList[0].expiredDate;
                self.addpersonalinfo.foreignemployee = self.PersonalList[0].foreign_Employee;
                self.addpersonalinfo.employeetype = self.PersonalList[0].employeeType;
                self.addpersonalinfo.hiredate = self.PersonalList[0].hiredDate;
                self.addpersonalinfo.probationdate = self.PersonalList[0].probationDate;
                self.addpersonalinfo.department = self.PersonalList[0].departmentName;
                self.changedepartment(self.addpersonalinfo.department);
                self.addpersonalinfo.division = self.PersonalList[0].divisionName;
                self.changedivision(self.addpersonalinfo.division);
                self.addpersonalinfo.section = self.PersonalList[0].section_ID;
                self.addpersonalinfo.position = self.PersonalList[0].positionID;
                self.addpersonalinfo.country = self.PersonalList[0].country_ID;
                self.changecountry();
                self.addpersonalinfo.province = self.PersonalList[0].province_ID;
                self.changeprovince();
                self.addpersonalinfo.district = self.PersonalList[0].district_ID;
                self.changedistrict();
                self.addpersonalinfo.subdistrict = self.PersonalList[0].sub_District_ID;
                self.changesubdistrict();
                self.addpersonalinfo.postalcode = parseInt(self.PersonalList[0].postal_Code);
                if (self.PersonalList[0].report_ID != null) {
                  self.addpersonalinfo.supervisorname = self.PersonalList[0].report_ID;
                }
                else {
                  self.addpersonalinfo.supervisorname = "";
                }
                self.addpersonalinfo.level = self.PersonalList[0].level;
                self.addpersonalinfo.terminatedate = self.PersonalList[0].terminateDate;
                self.addpersonalinfo.terminateeffectdate = self.PersonalList[0].terminateEffectiveDate;
                self.addpersonalinfo.calendartype = self.PersonalList[0].workday_Calendar;
                self.addpersonalinfo.shiftcode = self.PersonalList[0].shift_ID;
                self.addpersonalinfo.status = self.PersonalList[0].employeeStatus;
              }
              else {
                self.addpersonalinfo.gender = fortask2.gender;
                self.addpersonalinfo.foreignemployee = fortask2.foreignemployee;
                self.addpersonalinfo.religion = fortask2.religion;
                self.addpersonalinfo.DOB = fortask2.DOB;
                if (self.addpersonalinfo.DOB != "") {
                  self.getAge(self.addpersonalinfo.DOB);
                }
                self.addpersonalinfo.martialstatus = fortask2.status;
                self.addpersonalinfo.expired_date = fortask2.expireddate;
                self.addpersonalinfo.workpermitexpiredate = fortask2.workpermitexpire;
                self.addpersonalinfo.passportexpiredate = fortask2.passsportexpire;
                self.addpersonalinfo.employeetype = fortask2.employeetype;
                self.addpersonalinfo.hiredate = fortask2.hireddate;
                self.addpersonalinfo.probationdate = fortask2.probationdate;
                self.addpersonalinfo.department = fortask2.department;
                self.changedepartment(self.addpersonalinfo.department);
                self.addpersonalinfo.division = fortask2.division;
                self.changedivision(self.addpersonalinfo.division);
                self.addpersonalinfo.section = fortask2.section;
                self.addpersonalinfo.position = fortask2.position;
                self.addpersonalinfo.level = fortask2.level;
                self.addpersonalinfo.terminatedate = fortask2.terminatedate;
                self.addpersonalinfo.terminateeffectdate = fortask2.terminateeffectdate;
                self.addpersonalinfo.sectionID = self.PersonalList[0].section_ID;
                self.addpersonalinfo.divisonID = self.PersonalList[0].divisionID;
                self.addpersonalinfo.calendartype = fortask2.workdaycalendar;
                self.addpersonalinfo.shiftcode = fortask2.shiftcode;
                self.addpersonalinfo.status = fortask2.empstatus;
                self.addpersonalinfo.country = fortask2.country;
                self.changecountry();
                self.addpersonalinfo.province = fortask2.province;
                self.changeprovince();
                self.addpersonalinfo.district = fortask2.district;
                self.changedistrict();
                self.addpersonalinfo.subdistrict = fortask2.subdistrict;
                self.changesubdistrict();
                self.addpersonalinfo.postalcode = fortask2.postalcode;
              }
              if (self.addpersonalinfo.terminatedate != null && self.addpersonalinfo.terminatedate != "") {
                var getdate = moment(self.addpersonalinfo.terminatedate, "YYYY-MM-DD");
                var tdydate = moment();
                if (tdydate >= getdate) {
                  self.addpersonalinfo.status = 2;
                }
                else {
                  self.addpersonalinfo.status = 1;
                }
              }
              if (self.addpersonalinfo.foreignemployee == true) {
                self.disablepersonalID = true;
              }
              if (fortask3 == null) {
                self.addpersonalinfo.ReportToEmployeeId = self.PersonalList[0].report_ID;
              }
              else {
                self.addpersonalinfo.ReportToEmployeeId = fortask3.reportid;
                self.addpersonalinfo.ReportToEmployeeName = fortask3.reportname;
                self.addpersonalinfo.ReportToEmployeeCode = fortask3.reportcode;
              }
              if (localStorage.editworkpermitname == null)
              {
                self.workpermitUrl = self.PersonalList[0].work_Permit_Image;
              }
              if (localStorage.editothername == null)
              {
                self.otherimagename = self.PersonalList[0].other_Information;
                self.otherinfoUrl = self.PersonalList[0].driver_Licence;
                if (self.PersonalList[0].other_Information == "undefined" || self.PersonalList[0].other_Information == undefined)
                {
                  self.otherinfomation = "Other Information";
                  self.otherimagename = "Other Information";
                }
                else
                {
                  self.otherinfomation = self.PersonalList[0].other_Information;
                  self.otherimagename = self.PersonalList[0].other_Information;
                  self.showthis = false;
                }
              }
              else {
                if (localStorage.fortext != null) {
                  self.otherimagename = localStorage.fortext;
                }
                else {
                  self.otherimagename = "Other Information";
                }
              }
              if (localStorage.editpassportname == null) {
                self.passportUrl = self.PersonalList[0].passport_Image;
              }
              if (localStorage.editfilename == null) {
                self.personalIdUrl = self.PersonalList[0].personalID;
                self.myimage = self.PersonalList[0].personalID;
              }
              else {
                self.myimage = localStorage.editfilename;
              }
              self.addpersonalinfo.workpermitexpiredate = self.PersonalList[0].work_Permit_Expired_Date;
              self.addpersonalinfo.passportexpiredate = self.PersonalList[0].passport_Expired_Date;
              self.imageUrl1 = self.PersonalList[0].image ? self.PersonalList[0].image : "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group 3166.png";
              if (self.imageUrl1 == "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group 3166.png")
              {
                self.changepictrue = false;
              }
              else
              {
                self.changepictrue = true;
              }
              sessionStorage.setItem("personalimg", self.imageUrl1);
              store.state.personalimg = sessionStorage.getItem("personalimg");
              let tempedit = {
                personalid: self.PersonalList[0].personalID,
                workpermit: self.PersonalList[0].work_Permit_Image,
                otherimage: self.PersonalList[0].driver_Licence,
                passport: self.PersonalList[0].passport_Image,
              };
              if (localStorage.showforeditpersonal == "true")
              {
                self.showedit = false;
                self.showbyid = true;
              }
              else
              {
                self.showedit = true;
                self.showbyid = false;
              }
              let probationdate = moment(self.PersonalList[0].probationDate, "YYYY-MM-DD");
              let currentdate = moment();
              if (self.PersonalList[0].employeeStatus == 2)
              {
                self.addpersonalinfo.employeestatus = "Resign";
              }
              else if (currentdate.isBefore(probationdate))
              {
                self.addpersonalinfo.employeestatus = "Probation";
              }
              else
              {
                self.addpersonalinfo.employeestatus = "Permanent";
              }
              localStorage.setItem("edit", JSON.stringify(tempedit));
              self.GetReportToPersonalData();
              //self.LogTrace(null, "Get Personal Information", 14, "Critical");
            }
          })
          .catch(function (error) {
            self.LogTrace(error, "Get Personal Information Fail", 14, "Critical");
            self.loadingdialog = false;
          });
      }
      else if (localStorage.empcode != null) {
        let temp = {
          employee_Code: localStorage.empcode,
          company_ID: store.state.companyID,
        };
        axios.post(`${self.url}PersonalInfo/GetPersonalInfoByEmpcode`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.PersonalList = response.data.data;
              self.addpersonalinfo.Activeemployee = self.Activeemplist[0].activeemp;
              if (localStorage.mydisable == "false") {
                self.disableall = false;
                self.disablepersonalID = false;
              }
              else {
                self.disableall = true;
                self.disablepersonalID = true;
              }
              if (localStorage.showforeditpersonalprofile == "true") {
                self.showedit = false;
                self.showbycode = true;
              }
              else {
                self.showedit = true;
                self.showbycode = false;
                self.showsave = false;
              }
              if (fortask1 == null) {
                self.addpersonalinfo.employeecode = self.PersonalList[0].employee_Code;
                self.addpersonalinfo.prefix = self.PersonalList[0].prefix;
                self.addpersonalinfo.firstname = self.PersonalList[0].name;
                self.addpersonalinfo.lastname = self.PersonalList[0].lastName;
                self.addpersonalinfo.nickname = self.PersonalList[0].nickname;
                self.addpersonalinfo.taxpayerID = self.PersonalList[0].taxpayerID;
                if (self.PersonalList[0].probation_Period != null) {
                  self.addpersonalinfo.probationperiod = self.PersonalList[0].probation_Period;
                }
                else {
                  self.addpersonalinfo.probationperiod = 119;
                }
                self.addpersonalinfo.housenumber = self.PersonalList[0].houseNumber;
                self.addpersonalinfo.telephonenum = self.PersonalList[0].telephone;
                self.addpersonalinfo.mobile_number = self.PersonalList[0].mobile;
                self.addpersonalinfo.email = self.PersonalList[0].email;
                self.addpersonalinfo.personalID_Number = self.PersonalList[0].personalID_Number;
                self.addpersonalinfo.ReportToEmployeeId = self.PersonalList[0].report_ID;
                self.passport = self.PersonalList[0].passport;
                self.workpermitname = self.PersonalList[0].work_Permit;
              }
              else {
                self.addpersonalinfo.employeecode = fortask1.employeecode;
                self.addpersonalinfo.prefix = fortask1.prefix;
                self.addpersonalinfo.firstname = fortask1.firstname;
                self.addpersonalinfo.lastname = fortask1.lastname;
                self.addpersonalinfo.nickname = fortask1.nickname;
                //self.addpersonalinfo.age = fortask1.age;
                self.addpersonalinfo.taxpayerID = fortask1.taxid;
                self.addpersonalinfo.probationperiod = fortask1.probationperiod;
                self.addpersonalinfo.housenumber = fortask1.house;
                self.addpersonalinfo.telephonenum = fortask1.tele;
                self.addpersonalinfo.mobile_number = fortask1.mobile;
                self.addpersonalinfo.email = fortask1.email;
                self.addpersonalinfo.personalID_Number = fortask1.personalID_Number;
                self.passport = fortask1.passport;
                self.workpermitname = fortask1.workpermitname;
              }
              if (fortask2 == null) {
                self.addpersonalinfo.gender = self.PersonalList[0].gender;
                self.addpersonalinfo.religion = self.PersonalList[0].religion;
                self.addpersonalinfo.DOB = self.PersonalList[0].birthDate;
                self.addpersonalinfo.age = self.PersonalList[0].age;
                self.addpersonalinfo.ReportToEmployeeId = self.PersonalList[0].report_ID;
                self.addpersonalinfo.martialstatus = self.PersonalList[0].status;
                self.addpersonalinfo.expired_date = self.PersonalList[0].expiredDate;
                self.addpersonalinfo.foreignemployee = self.PersonalList[0].foreign_Employee;
                // self.disablepersonalID = true;
                self.addpersonalinfo.employeetype = self.PersonalList[0].employeeType;
                self.addpersonalinfo.hiredate = self.PersonalList[0].hiredDate;
                self.addpersonalinfo.probationdate = self.PersonalList[0].probationDate;
                self.addpersonalinfo.department = self.PersonalList[0].departmentName;
                self.changedepartment(self.addpersonalinfo.department);
                self.addpersonalinfo.division = self.PersonalList[0].divisionName;
                self.changedivision(self.addpersonalinfo.division);
                self.addpersonalinfo.section = self.PersonalList[0].section_ID;
                self.addpersonalinfo.position = self.PersonalList[0].positionID;
                self.addpersonalinfo.supervisorname = self.PersonalList[0].report_ID;
                self.addpersonalinfo.level = self.PersonalList[0].level;
                self.addpersonalinfo.terminatedate = self.PersonalList[0].terminateDate;
                self.addpersonalinfo.terminateeffectdate = self.PersonalList[0].terminateEffectiveDate;
                self.addpersonalinfo.calendartype = self.PersonalList[0].workday_Calendar;
                self.addpersonalinfo.shiftcode = self.PersonalList[0].shift_ID;
                self.addpersonalinfo.status = self.PersonalList[0].employeeStatus;
              }
              else {
                self.addpersonalinfo.gender = fortask2.gender;
                self.addpersonalinfo.foreignemployee = fortask2.foreignemployee;
                self.addpersonalinfo.religion = fortask2.religion;
                self.addpersonalinfo.DOB = fortask2.DOB;
                if (self.addpersonalinfo.DOB != "") {
                  self.getAge(self.addpersonalinfo.DOB);
                }
                self.addpersonalinfo.martialstatus = fortask2.status;
                self.addpersonalinfo.expired_date = fortask2.expireddate;
                self.addpersonalinfo.workpermitexpiredate = fortask2.workpermitexpire;
                self.addpersonalinfo.passportexpiredate = fortask2.passsportexpire;
                self.addpersonalinfo.employeetype = fortask2.employeetype;
                self.addpersonalinfo.hiredate = fortask2.hireddate;
                self.addpersonalinfo.probationdate = fortask2.probationdate;
                self.addpersonalinfo.department = fortask2.department;
                self.changedepartment(self.addpersonalinfo.department);
                self.addpersonalinfo.division = fortask2.division;
                self.changedivision(self.addpersonalinfo.division);
                self.addpersonalinfo.section = fortask2.section;
                self.addpersonalinfo.position = fortask2.position;
                self.addpersonalinfo.level = fortask2.level;
                self.addpersonalinfo.terminatedate = fortask2.terminatedate;
                self.addpersonalinfo.terminateeffectdate = fortask2.terminateeffectdate;
                self.addpersonalinfo.calendartype = fortask2.workdaycalendar;
                //self.addpersonalinfo.shiftcode = fortask2.shiftcode;
                if (self.PersonalList[0].shiftcodename != "") {
                  self.addpersonalinfo.shiftcode =
                    self.PersonalList[0].shift_ID;
                }
                self.addpersonalinfo.status = fortask2.empstatus;
                self.addpersonalinfo.postalcode = fortask2.postalcode;
              }
              if (self.addpersonalinfo.terminatedate != null && self.addpersonalinfo.terminatedate != "") {
                var getdate = moment(self.addpersonalinfo.terminatedate, "YYYY-MM-DD");
                var tdydate = moment();
                if (tdydate >= getdate) {
                  self.addpersonalinfo.status = 2;
                }
                else {
                  self.addpersonalinfo.status = 1;
                }
              }
              if (localStorage.workpermitname == null) {
                self.workpermitUrl = self.PersonalList[0].work_Permit_Image;
              }
              if (self.addpersonalinfo.foreignemployee == true) {
                self.disablepersonalID = true;
              }
              if (localStorage.othername == null) {
                self.otherimagename = self.PersonalList[0].other_Information;
                self.otherinfoUrl = self.PersonalList[0].driver_Licence;
                if (self.PersonalList[0].other_Information == "undefined" || self.PersonalList[0].other_Information == undefined) {
                  self.otherinfomation = "Other Information";
                  self.otherimagename = "Other Information";
                }
                else {
                  self.otherinfomation = self.PersonalList[0].other_Information;
                  self.otherimagename = self.PersonalList[0].other_Information;
                  self.showthis = false;
                }
              }
              else {
                self.otherimagename = localStorage.fortext;
              }
              if (localStorage.passportname == null) {
                self.passportUrl = self.PersonalList[0].passport_Image;
              }
              if (self.PersonalList[0].personalID != null) {
                self.personalIdUrl = self.PersonalList[0].personalID;
                self.myimage = self.PersonalList[0].personalID;
              }
              else {
                self.myimage = localStorage.filename;
              }
              self.addpersonalinfo.workpermitexpiredate = self.PersonalList[0].work_Permit_Expired_Date;
              self.addpersonalinfo.passportexpiredate = self.PersonalList[0].passport_Expired_Date;
              self.addpersonalinfo.country = self.PersonalList[0].country_ID;
              self.changecountry();
              self.addpersonalinfo.province = self.PersonalList[0].province_ID;
              self.changeprovince();
              self.addpersonalinfo.district = self.PersonalList[0].district_ID;
              self.changedistrict();
              self.addpersonalinfo.subdistrict = self.PersonalList[0].sub_District_ID;
              self.changesubdistrict();
              self.addpersonalinfo.postalcode = parseInt(self.PersonalList[0].postal_Code);
              self.ss = true;
              self.imageUrl1 = self.PersonalList[0].image;
              if (self.imageUrl1 == "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group 3166.png") {
                self.changepictrue = false;
              }
              else {
                self.changepictrue = true;
              }
              self.loadingdialog = false;
              let tempedit = {
                personalid: self.PersonalList[0].personalID,
                workpermit: self.PersonalList[0].work_Permit_Image,
                otherimage: self.PersonalList[0].driver_Licence,
                passport: self.PersonalList[0].passport_Image,
              };
              // self.showedit = true;
              localStorage.setItem("edit", JSON.stringify(tempedit));
              self.GetReportToPersonalData();
              // self.LogTrace(null, "Get Personal Information", 14, "Critical");
            }
          })
          .catch(function (error) {
            self.LogTrace(error, "Get Personal Information Fail", 14, "Critical");
            self.loadingdialog = false;
          });
      }
      else {
        self.showsave = true;
        self.addpersonalinfo.ReportToEmployeeId = store.state.firstUserID;
        self.GetReportToPersonalData();
      }
    },

    // Add personal information
    AddPersonalinfo() {
      let self = this;
      if (self.imageUrl2 == "" || self.imageUrl2 == undefined)
      {
        self.imageUrl2 = "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group 3166.png";
      }
      this.error.errormessageempid = !this.addpersonalinfo.employeecode ? "Employee ID is required" : "";
      this.error.errormessageprefix = !this.addpersonalinfo.prefix ? "Prefix is required" : "";
      this.error.errormessagename = !this.addpersonalinfo.firstname ? "First name is required" : "";
      this.error.errormessagelastname = !this.addpersonalinfo.lastname ? "Last name is required" : "";
      this.error.errormessagegender = !this.addpersonalinfo.gender ? "Gender is required" : "";
      this.error.errormessagereligion = !this.addpersonalinfo.religion ? "Religion is required" : "";
      this.error.errormessageDOB = !this.addpersonalinfo.DOB ? "Date of birth is required" : "";
      this.error.errormessageage = !this.addpersonalinfo.age ? "Age is required" : "";
      this.error.errormessagemartialstatus = !this.addpersonalinfo.martialstatus ? "Marital status is required" : "";
      if (this.addpersonalinfo.foreignemployee == true) {
        this.error.errormessagepassport = !this.passport ? "Please fill in the Passport field" : "";
      }
      if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
        if (this.addpersonalinfo.foreignemployee == false) {
          this.error.errormessagetaxpayer = !this.addpersonalinfo.taxpayerID ? "Tax payer ID is required" : "";
        }
      }
      this.error.errormessageemptype = !this.addpersonalinfo.employeetype ? "Employee Type is required" : "";
      this.error.errormessagehiredate = !this.addpersonalinfo.hiredate ? this.$t("ErrorHiredDate") : "";
      this.error.errormessageprobationperiod = this.addpersonalinfo.probationperiod == null && this.addpersonalinfo.employeestatus == "Probation" ? "Probation Period is required" : "";
      this.error.errormessageprobationdate = !this.addpersonalinfo.probationdate ? "Probation date is required" : "";
      this.error.errormessagedepartment = !this.addpersonalinfo.department ? "Department is required" : "";
      this.error.errormessagedivision = !this.addpersonalinfo.division ? "Division is required" : "";
      this.error.errormessagesection = !this.addpersonalinfo.section ? "Section is required" : "";
      this.error.errormessageposition = !this.addpersonalinfo.position ? "Position is required" : "";
      this.error.errormessagesupervisor = !this.addpersonalinfo.supervisorname ? "Please fill in the required fields" : "";
      if (this.addpersonalinfo.level != 0) {
        this.error.errormessagelvl = !this.addpersonalinfo.level ? "Level is required" : "";
      }
      if (this.addpersonalinfo.level == 0) {
        this.error.errormessagelvl = "";
      }
      // this.error.errormessageterminatedate = !this.addpersonalinfo.terminatedate ? "Please fill in the required fields" : "";
      this.error.errormessageterminatedate = this.addpersonalinfo.status === 2 && !this.addpersonalinfo.terminatedate ? "Please fill in the required fields" : "";
      this.error.errormessageterminateeffectivedate = !this.addpersonalinfo.terminateeffectdate ? "Please fill in the required fields" : "";
      this.error.errormessagestatus = !this.addpersonalinfo.status ? "Status is required" : "";
      this.error.errormessagecountry = !this.addpersonalinfo.country ? "Country is required" : "";
      this.error.errormessageprovince = !this.addpersonalinfo.province ? "Province is required" : "";
      this.error.errormessagedistrict = !this.addpersonalinfo.district ? "District is required" : "";
      this.error.errormessagesubdistrict = !this.addpersonalinfo.subdistrict ? "Subdistrict is required" : "";
      this.error.errormessagepostalcode = !this.addpersonalinfo.postalcode ? "Postal code is required" : "";
      this.error.errormessagehouse = !this.addpersonalinfo.housenumber ? "House number is required" : "";
      this.error.errormessagemobile = !this.addpersonalinfo.mobile_number ? "Mobile number is required" : "";
      this.error.errormessageemail = !this.addpersonalinfo.email ? "Email is required" : "";
      if (store.state.roleID != "Admin" && self.empCount > 1) {
        this.error.errormessagereportid = !this.addpersonalinfo.ReportToEmployeeId ? "Please Assign" : "";
      }
      if (store.state.roleID == "Admin" && self.empCount >= 1) {
        this.error.errormessagereportid = !this.addpersonalinfo.ReportToEmployeeId ? "Please Assign" : "";
      }
      if (self.addpersonalinfo.terminatedate != null) {
        var getdate = moment(self.addpersonalinfo.terminatedate, "YYYY-MM-DD");
        var tdydate = moment();
        if (tdydate >= getdate) {
          self.addpersonalinfo.status = 2;
        }
        else {
          self.addpersonalinfo.status = 1;
        }
      }
      self.loadingdialog = true;
      let emailvali = true;
      if (self.addpersonalinfo.email != "" && self.addpersonalinfo.email != null) {
        emailvali = self.validateEmail(self.addpersonalinfo.email);
      }
      else {
        emailvali = true;
      }

      if (self.addpersonalinfo.foreignemployee == null) {
        self.addpersonalinfo.foreignemployee = false;
      }
      if (this.imageUrl2 == "")
      {
        this.imageUrl2 = "https://optimisticpathfiles.blob.core.windows.net/optimisticimagefile/Group 3166.png";
      }
      var tempvalidate = this.validatepersonalinfo();
      let validateemp = true;
      if (self.addpersonalinfo.status == 1) {
        if (self.addpersonalinfo.PckgEmployeee != 0) {
          if (self.addpersonalinfo.Activeemployee >= self.addpersonalinfo.PckgEmployeee) {
            validateemp = false;
          }
          else {
            validateemp = true;
          }
        }
        else {
          validateemp = true;
        }
      }
      else {
        validateemp = true;
      }

      let mycodedata = self.Activeemplist.filter(
        (x) => x.employee_Code == self.addpersonalinfo.employeecode
      );
      if (mycodedata.length != 0) {
        self.addpersonalinfo.duplicatecode = true;
      }

      if (validateemp == true) {
        if (self.addpersonalinfo.duplicatecode != true) {
          if (tempvalidate == true) {
            if (emailvali == true) {
              let tempadd = {
                employee_Code: self.addpersonalinfo.employeecode,
                prefix: self.addpersonalinfo.prefix,
                name: self.addpersonalinfo.firstname,
                lastName: self.addpersonalinfo.lastname,
                nickname: self.addpersonalinfo.nickname,
                gender: self.addpersonalinfo.gender,
                religion: self.addpersonalinfo.religion,
                birthDate: self.addpersonalinfo.DOB,
                age: parseInt(self.addpersonalinfo.age),
                status: self.addpersonalinfo.martialstatus,
                image: self.imageUrl2,
                personalID: self.personalIdUrl,
                expiredDate: self.addpersonalinfo.expired_date,
                taxpayerID: self.addpersonalinfo.taxpayerID,
                foreign_Employee: self.addpersonalinfo.foreignemployee,
                work_Permit: self.workpermitname,
                work_Permit_Image: self.workpermitUrl,
                work_Permit_Expired_Date: self.addpersonalinfo.workpermitexpiredate,
                passport: self.passport,
                passport_Image: self.passportUrl,
                passport_Expired_Date: self.addpersonalinfo.passportexpiredate,
                driver_Licence: null,
                other_Information: self.otherimagename,
                employeeType: self.addpersonalinfo.employeetype,
                hiredDate: new Date(self.addpersonalinfo.hiredate),
                probation_Period: self.addpersonalinfo.probationperiod.toString(),
                probationDate: self.addpersonalinfo.probationdate,
                department: self.addpersonalinfo.department,
                division: self.addpersonalinfo.division,
                section_ID: self.addpersonalinfo.section,
                positionID: parseInt(self.addpersonalinfo.position),
                level: parseInt(self.addpersonalinfo.level),
                terminateDate: self.addpersonalinfo.terminatedate,
                terminateEffectiveDate: self.addpersonalinfo.terminateeffectdate,
                workday_Calendar: 0,
                shift_ID: self.addpersonalinfo.shiftcode,
                employeeStatus: self.addpersonalinfo.status,
                houseNumber: self.addpersonalinfo.housenumber,
                sub_District_ID: self.addpersonalinfo.subdistrict,
                district_ID: self.addpersonalinfo.district,
                province_ID: self.addpersonalinfo.province,
                country_ID: self.addpersonalinfo.country,
                postal_Code: self.addpersonalinfo.postalcode,
                telephone: self.addpersonalinfo.telephonenum,
                mobile: self.addpersonalinfo.mobile_number,
                email: self.addpersonalinfo.email,
                company_ID: store.state.companyID,
                personalID_Number: self.addpersonalinfo.personalID_Number,
                report_ID: parseInt(self.addpersonalinfo.ReportToEmployeeId),
                attachments: self.$store.getters.getUploadedFiles.map(file => ({
                  attachment_Name: file.docname,
                  attachment_Url: file.imgurl,
                  // employee_ID: parseInt(self.addpersonalinfo.EmployeeId) || 0,
                  filetype: file.type
                }))
              };
              axios.post(`${self.url}PersonalInfo/AddPersonalInfo`, tempadd)
                .then(function (response) {
                  self.loadingdialog = false;
                  if (response.data.status == 0) {
                    alert(response.data.message);
                    // if (response.data.message == "Add Successfully") {
                      self.addEducation();
                      // self.getEd();
                      self.showedit = true;
                      self.showsave = false;
                      self.showbyid = false;
                      self.disableall = true;
                      self.error.errormessagepassport = "";
                      localStorage.setItem("empcode", self.addpersonalinfo.employeecode);
                      localStorage.setItem("empType", self.addpersonalinfo.employeetype);
                      self.getpersonalinfo();
                      localStorage.setItem("locktab", "1st");
                      self.$router.push(`/PersonnelManagement/NewEmployee/NewPersonalInformation/Salary`).catch(() => { });
                    // }
                  }
                  else {
                    alert(response.data.message);
                  }
                })
                .catch(function (error) {
                  self.LogTrace(error, "Add  Personal Information Fail", 14, "Low");
                  alert(error);
                  self.loadingdialog = false;
                });
            }
            else {
              alert("please fill the correct email format");
              self.loadingdialog = false;
            }
          }
          else {
            self.loadingdialog = false;
            this.validateerror();
          }
        }
        else {
          alert("The employee ID is already linked with another user in our system. Please use a different one");
          self.loadingdialog = false;
          self.addpersonalinfo.duplicatecode = false;
        }
      }
      else {
        alert("Your active employee reach limit amount and have to contact optimistic admin.");
        self.loadingdialog = false;
      }
      this.addShortTraining();
      this.addLanguage();
    },

    // Update personal information  with employee ID
    UpdatePersonalinfo() {
      let self = this;
      this.error.errormessageempid = !this.addpersonalinfo.employeecode ? "Employee ID is required" : "";
      this.error.errormessageprefix = !this.addpersonalinfo.prefix ? "Prefix is required" : "";
      this.error.errormessagename = !this.addpersonalinfo.firstname ? "First name is required" : "";
      this.error.errormessagelastname = !this.addpersonalinfo.lastname ? "Last name is required" : "";
      this.error.errormessagegender = !this.addpersonalinfo.gender ? "Gender is required" : "";
      this.error.errormessagereligion = !this.addpersonalinfo.religion ? "Religion is required" : "";
      this.error.errormessageDOB = !this.addpersonalinfo.DOB ? "Date of birth is required" : "";
      this.error.errormessageage = !this.addpersonalinfo.age ? "Age is required" : "";
      this.error.errormessagemartialstatus = !this.addpersonalinfo.martialstatus ? "Marital status is required" : "";
      if (this.addpersonalinfo.foreignemployee == true) {
        this.error.errormessagepassport = !this.passport ? "Please fill in the Passport field" : "";
      }
      if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
        if (this.addpersonalinfo.foreignemployee == false) {
          this.error.errormessagetaxpayer = !this.addpersonalinfo.taxpayerID ? "Tax payer ID is required" : "";
        }
      }
      this.error.errormessageemptype = !this.addpersonalinfo.employeetype ? "Employee Type is required" : "";
      this.error.errormessagehiredate = !this.addpersonalinfo.hiredate ? this.$t("ErrorHiredDate") : "";
      this.error.errormessageprobationperiod = !this.addpersonalinfo.probationperiod && this.addpersonalinfo.employeestatus == "Probation" ? "Probation period is required" : "";
      this.error.errormessageprobationdate = !this.addpersonalinfo.probationdate ? "Probation date is required" : "";
      this.error.errormessagedepartment = !this.addpersonalinfo.department ? "Department is required" : "";
      this.error.errormessagedivision = !this.addpersonalinfo.division ? "Division is required" : "";
      this.error.errormessagesection = !this.addpersonalinfo.section ? "Section is required" : "";
      this.error.errormessageposition = !this.addpersonalinfo.position ? "Position is required" : "";
      this.error.errormessagesupervisor = !this.addpersonalinfo.supervisorname ? "Please fill in the required fields" : "";
      if (this.addpersonalinfo.level != 0) {
        this.error.errormessagelvl = !this.addpersonalinfo.level ? "Level is required" : null;
      }
      if (this.addpersonalinfo.level == 0) {
        this.error.errormessagelvl = "";
      }
      // this.error.errormessageterminatedate = !this.addpersonalinfo.terminatedate ? "Please fill in the required fields" : "";
      this.error.errormessageterminatedate = this.addpersonalinfo.status === 2 && !this.addpersonalinfo.terminatedate ? "Please fill in the required fields" : "";
      this.error.errormessageterminateeffectivedate = !this.addpersonalinfo.terminateeffectdate ? "Please fill in the required fields" : "";
      this.error.errormessageshiftcode = !this.addpersonalinfo.shiftcode ? "Please fill in the required fields" : "";
      this.error.errormessagestatus = !this.addpersonalinfo.status ? "Status is required" : "";
      this.error.errormessagecountry = !this.addpersonalinfo.country ? "Country is required" : "";
      this.error.errormessageprovince = !this.addpersonalinfo.province ? "Province is required" : "";
      this.error.errormessagedistrict = !this.addpersonalinfo.district ? "District is required" : "";
      this.error.errormessagesubdistrict = !this.addpersonalinfo.subdistrict ? "Subdistrict is required" : "";
      this.error.errormessagepostalcode = !this.addpersonalinfo.postalcode ? "Postal code is required" : "";
      this.error.errormessagehouse = !this.addpersonalinfo.housenumber ? "House number is required" : "";
      this.error.errormessagemobile = !this.addpersonalinfo.mobile_number ? "Mobile is required" : "";
      this.error.errormessageemail = !this.addpersonalinfo.email ? "Email is required" : "";
      if (store.state.roleID != "Admin" && self.empCount > 1) {
        this.error.errormessagereportid = !this.addpersonalinfo.ReportToEmployeeId ? "Please Assign" : "";
      }
      if (store.state.roleID == "Admin" && self.empCount > 1) {
        this.error.errormessagereportid = !this.addpersonalinfo.ReportToEmployeeId ? "Please Assign" : "";
      }
      if (self.addpersonalinfo.terminatedate != null) {
        var getdate = moment(self.addpersonalinfo.terminatedate, "YYYY-MM-DD");
        var tdydate = moment();
        if (tdydate >= getdate) {
          self.addpersonalinfo.status = 2;
        }
        else {
          self.addpersonalinfo.status = 1;
        }
      }
      self.loadingdialog = true;
      if (self.addpersonalinfo.foreignemployee == null) {
        self.addpersonalinfo.foreignemployee = false;
      }
      if (self.imageUrl2 == "")
      {
        self.imageUrl2 = self.PersonalList[0].image;
      }
      if (self.$route.params.id != null) {
        let emailvali = true;
        if (self.addpersonalinfo.email != "" && self.addpersonalinfo.email != null) {
          emailvali = self.validateEmail(self.addpersonalinfo.email);
        }
        else {
          emailvali = true;
        }

        let validateemp = true;
        if (self.addpersonalinfo.status == 1) {
          if (self.addpersonalinfo.PckgEmployeee != 0) {
            if (self.addpersonalinfo.Activeemployee >= self.addpersonalinfo.PckgEmployeee) {
              validateemp = false;
            }
            else {
              validateemp = true;
            }
          }
          else {
            validateemp = true;
          }
        }
        else {
          validateemp = true;
        }

        let termindatecheck = false;
        if (self.addpersonalinfo.status == 2) {
          if(self.addpersonalinfo.terminatedate == null){
              termindatecheck = false;
            }
            else{
              termindatecheck = true;
            }
        }
        else{
              termindatecheck = true;
            }

        if (validateemp == true) {
          var tempeditvalidate = self.validateditpersonalinfo();
          if (tempeditvalidate == true) {
            if(termindatecheck == true){
              if (emailvali == true) {
              let tempedit = {
                employee_ID: parseInt(self.$route.params.id),
                employee_Code: self.addpersonalinfo.employeecode,
                prefix: self.addpersonalinfo.prefix,
                name: self.addpersonalinfo.firstname,
                lastName: self.addpersonalinfo.lastname,
                nickname: self.addpersonalinfo.nickname,
                gender: self.addpersonalinfo.gender,
                religion: self.addpersonalinfo.religion,
                birthDate: self.addpersonalinfo.DOB,
                age: self.addpersonalinfo.age,
                status: self.addpersonalinfo.martialstatus,
                image: self.ss == true ? self.imageUrl1 : self.imageUrl2,
                personalID: self.personalIdUrl,
                expiredDate: self.addpersonalinfo.expired_date,
                taxpayerID: self.addpersonalinfo.taxpayerID,
                foreign_Employee: self.addpersonalinfo.foreignemployee,
                work_Permit: self.workpermitname,
                work_Permit_Image: self.workpermitUrl,
                work_Permit_Expired_Date: self.addpersonalinfo.workpermitexpiredate,
                passport: self.passport,
                passport_Image: self.passportUrl,
                passport_Expired_Date: self.addpersonalinfo.passportexpiredate,
                driver_Licence: null,
                other_Information: self.otherimagename,
                employeeType: self.addpersonalinfo.employeetype,
                hiredDate: new Date(self.addpersonalinfo.hiredate),
                probation_Period: self.addpersonalinfo.probationperiod.toString(),
                probationDate: self.addpersonalinfo.probationdate,
                department: self.addpersonalinfo.department,
                division: self.addpersonalinfo.division,
                section_ID: self.addpersonalinfo.section,
                positionID: parseInt(self.addpersonalinfo.position),
                level: parseInt(self.addpersonalinfo.level),
                terminateDate: self.addpersonalinfo.terminatedate,
                terminateEffectiveDate: self.addpersonalinfo.terminateeffectdate,
                workday_Calendar: self.addpersonalinfo.calendartype,
                shift_ID: self.addpersonalinfo.shiftcode,
                employeeStatus: self.addpersonalinfo.status,
                houseNumber: self.addpersonalinfo.housenumber,
                country_ID: self.addpersonalinfo.country,
                province_ID: self.addpersonalinfo.province,
                district_ID: self.addpersonalinfo.district,
                sub_District_ID: self.addpersonalinfo.subdistrict,
                postal_Code: self.addpersonalinfo.postalcode,
                telephone: self.addpersonalinfo.telephonenum,
                mobile: self.addpersonalinfo.mobile_number,
                email: self.addpersonalinfo.email,
                user_ID: store.state.userid,
                company_ID: store.state.companyID,
                personalID_Number: self.addpersonalinfo.personalID_Number,
                report_ID: parseInt(self.addpersonalinfo.ReportToEmployeeId),
                created_By: parseInt(store.state.employeeID),
              };
              //console.log(tempedit)
              axios.post(`${self.url}PersonalInfo/UpdatePersonalInfo`, tempedit)
                .then(function (response) {
                  if (response.data.status == 0) {
                    alert(response.data.message);
                    self.loadingdialog = false;
                    if (response.data.message == "Update Successfully") {
                      self.getpersonalinfo();
                      self.showbysid = false;
                      self.resetbtn = false;
                      self.showbyid = false;
                      self.error.errormessagepassport = "";
                      self.showsave = false;
                      self.showedit = true;
                      self.disableall = true;
                      self.disablepersonalID = true;
                      localStorage.showforeditpersonal = false;
                      localStorage.mydisable = true;
                      // Emit an event with the tabId and conditionMet
                      self.$emit('enableNextTab');
                    }
                  }
                })
                .catch(function (error) {
                  self.LogTrace(error, "Update Personal Information Fail", 14, "Medium");
                  alert(error);
                  self.loadingdialog = false;
                });
            }
            else {
              alert("Please fill the correct Email format");
              self.loadingdialog = false;
            }
          }else{
            alert("Please fill the terminate date");
            self.loadingdialog = false;
          }
            
          }
          else {
            self.validateediterror();
            self.loadingdialog = false;
          }
        }
        else {
          alert("Your active employee reach limit amount and have to contact optimistic admin.");
          self.loadingdialog = false;
        }
      }
    },

    // Update personal information from personal profile page
    async UpdatePersonalinfowithhSid() {
      let self = this;
      this.error.errormessageempid = !this.addpersonalinfo.employeecode ? "Employee ID is required" : "";
      this.error.errormessageprefix = !this.addpersonalinfo.prefix ? "Prefix is required" : "";
      this.error.errormessagename = !this.addpersonalinfo.firstname ? "First name is required" : "";
      this.error.errormessagelastname = !this.addpersonalinfo.lastname ? "Last name is required" : "";
      this.error.errormessagegender = !this.addpersonalinfo.gender ? "Gender is required" : "";
      this.error.errormessagereligion = !this.addpersonalinfo.religion ? "Religion is required" : "";
      this.error.errormessageDOB = !this.addpersonalinfo.DOB ? "Date of birth is required" : "";
      this.error.errormessageage = !this.addpersonalinfo.age ? "Age is required" : "";
      this.error.errormessagemartialstatus = !this.addpersonalinfo.martialstatus ? "Marital status is required" : "";
      if (this.addpersonalinfo.foreignemployee == true) {
        this.error.errormessagepassport = !this.passport ? "Please fill in the Passport field" : "";
      }
      if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
        if (this.addpersonalinfo.foreignemployee == false) {
          this.error.errormessagetaxpayer = !this.addpersonalinfo.taxpayerID ? "Tax payer ID is required" : "";
        }
      }
      this.error.errormessageemptype = !this.addpersonalinfo.employeetype ? "Employee type is required" : "";
      this.error.errormessagehiredate = !this.addpersonalinfo.hiredate ? this.$t("ErrorHiredDate") : "";
      this.error.errormessageprobationperiod = !this.addpersonalinfo.probationperiod && this.addpersonalinfo.employeestatus == "Probation" ? "Probation period is required" : "";
      this.error.errormessageprobationdate = !this.addpersonalinfo.probationdate ? "Probation date is required" : "";
      this.error.errormessagedepartment = !this.addpersonalinfo.department ? "Department is required" : "";
      this.error.errormessagedivision = !this.addpersonalinfo.division ? "Division is required" : "";
      this.error.errormessagesection = !this.addpersonalinfo.section ? "Section is required" : "";
      this.error.errormessageposition = !this.addpersonalinfo.position ? "Position is required" : "";
      this.error.errormessagesupervisor = !this.addpersonalinfo.supervisorname ? "Please fill in the required fields" : "";
      if (this.addpersonalinfo.level != 0) {
        this.error.errormessagelvl = !this.addpersonalinfo.level ? "Level is required" : "";
      }
      if (this.addpersonalinfo.level == 0) {
        this.error.errormessagelvl = "";
      }
      this.error.errormessagestatus = !this.addpersonalinfo.status ? "Status is required" : "";
      this.error.errormessageterminatedate = this.addpersonalinfo.status === 2 && !this.addpersonalinfo.terminatedate ? "Please fill in the required fields" : "";
      this.error.errormessageterminateeffectivedate = !this.addpersonalinfo.terminateeffectdate ? "Please fill in the required fields" : "";
      this.error.errormessagecountry = !this.addpersonalinfo.country ? "Country is required" : "";
      this.error.errormessageprovince = !this.addpersonalinfo.province ? "Province is required" : "";
      this.error.errormessagedistrict = !this.addpersonalinfo.district ? "District is required" : "";
      this.error.errormessagesubdistrict = !this.addpersonalinfo.subdistrict ? "Subdistrict is required" : "";
      this.error.errormessagepostalcode = !this.addpersonalinfo.postalcode ? "Postal code is required" : "";
      this.error.errormessagehouse = !this.addpersonalinfo.housenumber ? "House number is required" : "";
      this.error.errormessagemobile = !this.addpersonalinfo.mobile_number ? "Mobile number is required" : "";
      this.error.errormessageemail = !this.addpersonalinfo.email ? "Email is required" : "";
      if (store.state.roleID != "Admin" && self.empCount > 1) {
        this.error.errormessagereportid = !this.addpersonalinfo.ReportToEmployeeId ? "Please Assign" : "";
      }
      if (store.state.roleID == "Admin" && self.empCount > 1) {
        this.error.errormessagereportid = !this.addpersonalinfo.ReportToEmployeeId ? "Please Assign" : "";
      }
      if (self.addpersonalinfo.terminatedate != null) {
        var getdate = moment(self.addpersonalinfo.terminatedate, "YYYY-MM-DD");
        var tdydate = moment();
        if (tdydate >= getdate) {
          self.addpersonalinfo.status = 2;
        }
        else {
          self.addpersonalinfo.status = 1;
        }
      }
      self.loadingdialog = true;
      if (self.addpersonalinfo.foreignemployee == null)
      {
        self.addpersonalinfo.foreignemployee = false;
      }
      if (self.imageUrl2 == "")
      {
        if (self.PersonalList.length != 0)
        {
          if (self.PersonalList[0].image != null)
          {
            self.imageUrl2 = self.PersonalList[0].image;
          }
          else
          {
            self.imageUrl2 = self.imageUrl1;
          }
        }
        else
        {
          self.imageUrl2 = self.imageUrl1;
        }
      }
      if (localStorage.LocalPersonalidUrl != null) {
        self.personalIdUrl = localStorage.LocalPersonalidUrl;
      }
      if (localStorage.localworkpermitUrl != null) {
        self.workpermitUrl = localStorage.localworkpermitUrl;
      }
      if (localStorage.localPassportUrl != null) {
        self.passportUrl = localStorage.localPassportUrl;
      }
      if (localStorage.localotherinfoUrl != null) {
        self.otherinfoUrl = localStorage.localotherinfoUrl;
      }

      let emailvali = true;
      if (self.addpersonalinfo.email != "" && self.addpersonalinfo.email != null) {
        emailvali = self.validateEmail(self.addpersonalinfo.email);
      }
      else {
        emailvali = true;
      }

      let validateemp = true;
      if (self.addpersonalinfo.status == 1) {
        if (self.addpersonalinfo.PckgEmployeee != 0) {
          if (self.addpersonalinfo.Activeemployee >= self.addpersonalinfo.PckgEmployeee) {
            validateemp = false;
          }
          else {
            validateemp = true;
          }
        }
        else {
          validateemp = true;
        }
      }
      else {
        validateemp = true;
      }

      let termindatecheck = false;
        if (self.addpersonalinfo.status == 2) {
          if(self.addpersonalinfo.terminatedate == null){
              termindatecheck = false;
            }
            else{
              termindatecheck = true;
            }
        }
        else{
              termindatecheck = true;
        }
      var tempeditvalidate = self.validateditpersonalinfo();
      if (validateemp == true) {
        if (tempeditvalidate == true) {
          if(termindatecheck == true){
            if (emailvali == true) {
            let tempedit = {
              employee_ID: parseInt(store.state.employeeID),
              employee_Code: self.addpersonalinfo.employeecode,
              prefix: self.addpersonalinfo.prefix,
              name: self.addpersonalinfo.firstname,
              lastName: self.addpersonalinfo.lastname,
              nickname: self.addpersonalinfo.nickname,
              gender: self.addpersonalinfo.gender,
              religion: self.addpersonalinfo.religion,
              birthDate: self.addpersonalinfo.DOB,
              age: self.addpersonalinfo.age,
              status: self.addpersonalinfo.martialstatus,
              image: self.ss == true ? self.imageUrl1 : self.imageUrl2,
              personalID: self.personalIdUrl,
              expiredDate: self.addpersonalinfo.expired_date,
              taxpayerID: self.addpersonalinfo.taxpayerID,
              foreign_Employee: self.addpersonalinfo.foreignemployee,
              work_Permit: self.workpermitname,
              work_Permit_Image: self.workpermitUrl,
              work_Permit_Expired_Date: self.addpersonalinfo.workpermitexpiredate,
              passport: self.passport,
              passport_Image: self.passportUrl,
              passport_Expired_Date: self.addpersonalinfo.passportexpiredate,
              driver_Licence: null,
              other_Information: self.otherimagename,
              employeeType: self.addpersonalinfo.employeetype,
              hiredDate: new Date(self.addpersonalinfo.hiredate),
              probation_Period: self.addpersonalinfo.probationperiod.toString(),
              probationDate: self.addpersonalinfo.probationdate,
              department: self.addpersonalinfo.department,
              division: self.addpersonalinfo.division,
              section_ID: self.addpersonalinfo.section,
              positionID: parseInt(self.addpersonalinfo.position),
              level: parseInt(self.addpersonalinfo.level),
              terminateDate: self.addpersonalinfo.terminatedate,
              terminateEffectiveDate: self.addpersonalinfo.terminateeffectdate,
              workday_Calendar: self.addpersonalinfo.calendartype,
              shift_ID: self.addpersonalinfo.shiftcode,
              employeeStatus: self.addpersonalinfo.status,
              houseNumber: self.addpersonalinfo.housenumber,
              country_ID: self.addpersonalinfo.country,
              province_ID: self.addpersonalinfo.province,
              district_ID: self.addpersonalinfo.district,
              sub_District_ID: self.addpersonalinfo.subdistrict,
              postal_Code: self.addpersonalinfo.postalcode,
              telephone: self.addpersonalinfo.telephonenum,
              mobile: self.addpersonalinfo.mobile_number,
              email: self.addpersonalinfo.email,
              user_ID: store.state.userid,
              company_ID: store.state.companyID,
              personalID_Number: self.addpersonalinfo.personalID_Number,
              report_ID: parseInt(self.addpersonalinfo.ReportToEmployeeId),
              created_By: parseInt(store.state.employeeID),
            };
            await axios.post(`${self.url}PersonalInfo/UpdatePersonalInfo`, tempedit)
              .then(function (response) {
                if (response.data.status == 0) {
                  alert(response.data.message);
                  self.loadingdialog = false;
                  if (response.data.message == "Update Successfully") {
                    self.getpersonalinfo();
                    self.showbysid = false;
                    self.showbyid = false;
                    self.showsave = false;
                    self.showedit = true;
                    self.error.errormessagepassport = "";
                    self.disableall = true;
                    localStorage.showforpersonalprofile = false;
                  }
                }
              })
              .catch(function (error) {
                self.LogTrace(
                  error,
                  "Update Personal Information Fail",
                  14,
                  "Medium"
                );
                alert(error);
                self.loadingdialog = false;
              });
          }
          else {
            alert("Please fill the correct Email format");
            self.loadingdialog = false;
          }
          }
          else{
            alert("Please fill the terminate date");
            self.loadingdialog = false;
          }
          
        }
        else {
          self.validateediterror();
          self.loadingdialog = false;
        }
      }
      else {
        alert("Your active employee reach limit amount and have to contact optimistic admin.");
        self.loadingdialog = false;
      }
    },

    // update personal information from adding new employee
    UpdatePersonalinfoWithEmpcode() {
      let self = this;
      this.error.errormessageempid = !this.addpersonalinfo.employeecode ? "Employee ID is required" : "";
      this.error.errormessageprefix = !this.addpersonalinfo.prefix ? "Prefix is required" : "";
      this.error.errormessagename = !this.addpersonalinfo.firstname ? "First name is required" : "";
      this.error.errormessagelastname = !this.addpersonalinfo.lastname ? "Last name is required" : "";
      this.error.errormessageDOB = !this.addpersonalinfo.DOB ? "Date of birth is required" : "";
      this.error.errormessageage = !this.addpersonalinfo.age ? "Age is required" : "";
      if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
        if (this.addpersonalinfo.foreignemployee == false) {
          this.error.errormessagetaxpayer = !this.addpersonalinfo.taxpayerID ? "Tax payer ID is required" : "";
        }
      }
      this.error.errormessagehiredate = !this.addpersonalinfo.hiredate ? this.$t("ErrorHiredDate") : "";
      this.error.errormessageprobationperiod = !this.addpersonalinfo.probationperiod && this.addpersonalinfo.employeestatus == "Probation" ? "Probation period is required" : "";
      this.error.errormessageprobationdate = !this.addpersonalinfo.probationdate ? "Probation date is required" : "";
      this.error.errormessagecountry = !this.addpersonalinfo.country ? "Country is required" : "";
      this.error.errormessageprovince = !this.addpersonalinfo.province ? "Province is required" : "";
      this.error.errormessagedistrict = !this.addpersonalinfo.district ? "District is required" : "";
      this.error.errormessagesubdistrict = !this.addpersonalinfo.subdistrict ? "Subdistrict is required" : "";
      this.error.errormessagepostalcode = !this.addpersonalinfo.postalcode ? "Postal code is required" : "";
      this.error.errormessagehouse = !this.addpersonalinfo.housenumber ? "House number is requried" : "";

      if (this.addpersonalinfo.foreignemployee == true) {
        this.error.errormessagepassport = !this.passport ? "Please fill in the Passport field" : "";
      }
      this.error.errormessagemobile = !this.addpersonalinfo.mobile_number ? "Mobile is required" : "";
      this.error.errormessageemail = !this.addpersonalinfo.email ? "Email is required" : "";
      self.loadingdialog = true;
      if (self.addpersonalinfo.foreignemployee == null) {
        self.addpersonalinfo.foreignemployee = false;
      }
      if (self.imageUrl2 == "") {
        self.imageUrl2 = self.PersonalList[0].image;
      }
      if (localStorage.LocalPersonalidUrl != null) {
        self.personalIdUrl = localStorage.LocalPersonalidUrl;
      }
      if (localStorage.localworkpermitUrl != null) {
        self.workpermitUrl = localStorage.localworkpermitUrl;
      }
      if (localStorage.localPassportUrl != null) {
        self.passportUrl = localStorage.localPassportUrl;
      }
      if (localStorage.localotherinfoUrl != null) {
        self.otherinfoUrl = localStorage.localotherinfoUrl;
      }

      let emailvali = true;
      if (self.addpersonalinfo.email != "" && self.addpersonalinfo.email != null) {
        emailvali = self.validateEmail(self.addpersonalinfo.email);
      }
      else {
        emailvali = true;
      }
      if (self.addpersonalinfo.terminatedate != null) {
        var getdate = moment(self.addpersonalinfo.terminatedate, "YYYY-MM-DD");
        var tdydate = moment();
        if (tdydate >= getdate) {
          self.addpersonalinfo.status = 2;
        }
        else {
          self.addpersonalinfo.status = 1;
        }
      }
      var tempeditvalidate = self.validateditpersonalinfo();
      if (tempeditvalidate == true) {
        if (emailvali == true) {
          let tempedit = {
            employee_ID: parseInt(store.state.employeeID),
            employee_Code: self.addpersonalinfo.employeecode,
            prefix: self.addpersonalinfo.prefix,
            name: self.addpersonalinfo.firstname,
            lastName: self.addpersonalinfo.lastname,
            nickname: self.addpersonalinfo.nickname,
            gender: self.addpersonalinfo.gender,
            religion: self.addpersonalinfo.religion,
            birthDate: self.addpersonalinfo.DOB,
            age: self.addpersonalinfo.age,
            status: self.addpersonalinfo.martialstatus,
            image: self.imageUrl2,
            personalID: self.personalIdUrl,
            expiredDate: self.addpersonalinfo.expired_date,
            taxpayerID: self.addpersonalinfo.taxpayerID,
            foreign_Employee: self.addpersonalinfo.foreignemployee,
            work_Permit: self.workpermitname,
            work_Permit_Image: self.workpermitUrl,
            work_Permit_Expired_Date: self.addpersonalinfo.workpermitexpiredate,
            passport: self.passport,
            passport_Image: self.passportUrl,
            passport_Expired_Date: self.addpersonalinfo.passportexpiredate,
            driver_Licence: null,
            other_Information: self.otherimagename,
            employeeType: self.addpersonalinfo.employeetype,
            hiredDate: new Date(self.addpersonalinfo.hiredate),
            probation_Period: self.addpersonalinfo.probationperiod.toString(),
            probationDate: self.addpersonalinfo.probationdate,
            department: self.addpersonalinfo.department,
            division: self.addpersonalinfo.division,
            section_ID: self.addpersonalinfo.section,
            positionID: parseInt(self.addpersonalinfo.position),
            level: parseInt(self.addpersonalinfo.level),
            terminateDate: self.addpersonalinfo.terminatedate,
            terminateEffectiveDate: self.addpersonalinfo.terminateeffectdate,
            workday_Calendar: self.addpersonalinfo.calendartype,
            shift_ID: self.addpersonalinfo.shiftcode,
            employeeStatus: self.addpersonalinfo.status,
            houseNumber: self.addpersonalinfo.housenumber,
            country_ID: self.addpersonalinfo.country,
            province_ID: self.addpersonalinfo.province,
            district_ID: self.addpersonalinfo.district,
            sub_District_ID: self.addpersonalinfo.subdistrict,
            postal_Code: self.addpersonalinfo.postalcode,
            telephone: self.addpersonalinfo.telephonenum,
            mobile: self.addpersonalinfo.mobile_number,
            email: self.addpersonalinfo.email,
            user_ID: store.state.userid,
            company_ID: store.state.companyID,
            personalID_Number: self.addpersonalinfo.personalID_Number,
            report_ID: parseInt(self.addpersonalinfo.ReportToEmployeeId),
            created_By: parseInt(store.state.employeeID),
          };
          axios.post(`${self.url}PersonalInfo/UpdatePersonalinfowithcode`, tempedit)
            .then(function (response) {
              if (response.data.status == 0) {
                alert(response.data.message);
                self.loadingdialog = false;
                if (response.data.message == "Update Successfully") {
                  //location.reload();
                  self.getpersonalinfo();
                  self.UpdateED();
                  self.UpdateST();
                  self.UpdateLang();
                  self.showbysid = false;
                  self.showbyid = false;
                  self.showsave = false;
                  self.error.errormessagepassport = "";
                  self.showbycode = false;
                  self.showedit = false;
                  self.disableall = true;
                  self.disablepersonalID = true;
                  localStorage.showforeditpersonalprofile = false;
                  localStorage.mydisable = true;
                }
              }
            })
            .catch(function (error) {
              self.LogTrace(error, "Update Personal Information Fail", 14, "Medium");
              alert(error);
              self.loadingdialog = false;
            });
        }
        else {
          alert("Please fill the correct Email format");
          self.loadingdialog = false;
        }
      }
      else {
        self.validateediterror();
        self.loadingdialog = false;
      }
    },

    formatDate(date) {
      if (!date) return null;
      let finaldate = date.slice(0, 10).split("-");
      return finaldate[2] + "/" + finaldate[1] + "/" + finaldate[0];
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    GetDivision() {
      let self = this;
      let temp = { company_ID: store.state.companyID };
      axios.post(`${self.url}Division/GetDivisionByCom`, temp)
        .then(function (response) {
          self.divisionList = response.data.data;
        });
    },

    GetSectiion() {
      let self = this;
      let temp = { company_ID: store.state.companyID };
      axios.post(`${self.url}Section/GetSectionByCom`, temp)
        .then(function (response) {
          self.sectionList = response.data.data;
        });
    },

    GetAllPosition() {
      let self = this;
      let temp = { company_ID: store.state.companyID };
      axios.post(`${self.url}Position/GetallPosition`, temp)
        .then(function (response) {
          self.positionList = response.data.data;
        });
    },

    GetPosition() {
      let self = this;
      let temp = { company_ID: store.state.companyID };
      axios.post(`${self.url}Position/GetPosition`, temp)
        .then(function (response) {
          self.positionList = response.data.data;
        });
    },

    GetShiftCode() {
      let self = this;
      let temp = { company_ID: store.state.companyID };
      axios.post(`${self.url}ShiftCode/GetShiftCodebyCompanyID`, temp)
        .then(function (response) {
          self.ShiftCodeList = response.data.data;
          for (var i = 0; i <= self.ShiftCodeList.length - 1; i++) {
            if (self.ShiftCodeList[i].defaultShift == 1) {
              self.DefaultShiftCode = self.ShiftCodeList[i];
            }
          }
          if (self.addpersonalinfo.shiftcode == null || self.addpersonalinfo.shiftcode == "" || self.addpersonalinfo.shiftcode == 0) {
            self.addpersonalinfo.shiftcode = self.DefaultShiftCode.shift_ID;
          }
        });
    },

    // get country list
    GetCountry() {
      let self = this;
      axios.get(`${self.url}Country/GetCountryByCompanyID?Company_ID=${store.state.companyID}`)
        .then(function (response) {
          self.CountryList = response.data.data;
        });
    },

    GetSupervisor() {
      let self = this;
      let temp = { company_ID: store.state.companyID };
      axios.post(`${self.url}PersonalInfo/GetsupervisorID`, temp)
        .then(function (response) {
          self.SupervisorList = response.data.data;
        });
    },

    validateEmail(email) {
      var re =
        /* eslint-disable-next-line */
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email) || "invalid email";
    },

    // add education
    async addEducation() {
      let self = this;
      self.educationBackground = JSON.parse(localStorage.getItem("EdBackgroundEdu"));
      self.EducationList = [];
      let combileArray = [];
      if (self.educationBackground != null) {
        for (let i = 0; i < self.educationBackground.length; i++) {
          self.tempedu = {
            ...self.educationBackground[i],
            company_ID: store.state.companyID,
            employee_Code: self.addpersonalinfo.employeecode,
          };
          self.tempedu.gpa = self.tempedu.gpa.toString();
          combileArray.push(self.tempedu);
        }
        await axios.post(`${self.url}EducationBackground/ImportEducationBackground`, combileArray)
          .then(function (response) {
            if (response.data.status == 0) {
              self.getEd();
            }
          });
      }
    },

    async getEd() {
      let self = this;
      let ebIT = self.addpersonalinfo.employeecode;
      let temp = {};
      temp = {
        employee_Code: ebIT,
        company_ID: store.state.companyID,
      };
      await axios.post(`${self.url}EducationBackground/GetEducationBackgroundByEmployecodeAndCPID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.EducationList = response.data.data;
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    async getST() {
      let self = this;
      let ebIT = self.addpersonalinfo.employeecode;
      let temp = {};
      temp = {
        employee_Code: ebIT,
        company_ID: store.state.companyID,
      };
      await axios.post(`${self.url}ShortTraining/GetShortTrainingByEmployeIDAndCPID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ShortTrainingList = response.data.data;
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    async getLang() {
      let self = this;
      let ebIT = self.addpersonalinfo.employeecode;
      let temp = {};
      temp = {
        employee_Code: ebIT,
        company_ID: store.state.companyID,
      };
      await axios.post(`${self.url}Languages/GetLanguagesByEmployeIDAndCPID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LanguageList = response.data.data;
            //.log(self.LanguageList);
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    UpdateED() {
      let self = this;
      if (self.EducationList.length == 0) {
        self.addEducation();
      }
      else {
        self.DeleteOldEd();
        //self.addEducation();
      }
    },

    UpdateST() {
      let self = this;
      if (self.ShortTrainingList.length == 0) {
        self.addShortTraining();
      }
      else {
        self.DeleteOldST();
        // self.addShortTraining();
      }
    },

    UpdateLang() {
      let self = this;
      if (self.LanguageList.length == 0) {
        self.addLanguage();
      }
      else {
        self.DeleteOldLang();
        //self.addLanguage();
      }
    },

    async DeleteOldEd() {
      let self = this;
      let ebIT = self.addpersonalinfo.employeecode;
      let temp = {};
      temp = {
        employee_Code: ebIT,
        company_ID: store.state.companyID,
      };
      await axios.post(`${self.url}EducationBackground/DeleteOldEducatinBackgroundwithempcode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.addEducation();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    async DeleteOldST() {
      let self = this;
      let ebIT = self.addpersonalinfo.employeecode;
      let temp = {};
      temp = {
        employee_Code: ebIT,
        company_ID: store.state.companyID,
      };
      await axios.post(`${self.url}ShortTraining/DeleteOldShorttrainingwithempcode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.addShortTraining();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    async DeleteOldLang() {
      let self = this;
      let ebIT = self.addpersonalinfo.employeecode;
      let temp = {};
      temp = {
        employee_Code: ebIT,
        company_ID: store.state.companyID,
      };
      await axios.post(`${self.url}Languages/DeleteOldLanguagewithempcode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.addLanguage();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    // add short training
    addShortTraining() {
      let self = this;
      self.shortTraining = JSON.parse(localStorage.getItem("EdShortTraining"));
      let combileArraySt = [];
      self.ShortTrainingList = [];
      if (self.shortTraining != null) {
        for (let i = 0; i < self.shortTraining.length; i++) {
          this.tempeSt = {
            ...self.shortTraining[i],
            company_ID: store.state.companyID,
            employee_Code: self.addpersonalinfo.employeecode,
          };
          combileArraySt.push(this.tempeSt);
        }
        axios.post(`${self.url}ShortTraining/ImportShortTraining`, combileArraySt)
          .then(function (response) {
            if (response.data.status == 0) {
              self.getST();
            }
          });
      }
    },

    // add new language
    addLanguage() {
      let self = this;
      self.languages = JSON.parse(localStorage.getItem("EdLanguages"));
      let combileArrayLg = [];
      self.LanguageList = [];
      if (self.languages != null) {
        for (let i = 0; i < self.languages.length; i++) {
          this.tempeLg = {
            ...self.languages[i],
            company_ID: store.state.companyID,
            employee_Code: self.addpersonalinfo.employeecode,
          };
          if (self.tempeLg.test_Date == "-") {
            self.tempeLg.test_Date = null;
          }
          else if (self.tempeLg.test_Date) {
            let newdate = self.tempeLg.test_Date.split("/").reverse().join("-");
            self.tempeLg.test_Date = newdate;
          }
          if (self.tempeLg.score == "-") {
            self.tempeLg.score = 0;
          }
          combileArrayLg.push(this.tempeLg);
        }
        axios.post(`${self.url}Languages/ImportLanguages`, combileArrayLg)
          .then(function (response) {
            if (response.data.status == 0) {
              self.getLang();
            }
          });
      }
    },

    // validation of field and select when add
    validatepersonalinfo() {
      let self = this;
      let mobilevali = self.mobilenumbervalidation(self.addpersonalinfo.mobile_number);

      let passcondi = false;
      if (self.addpersonalinfo.foreignemployee == true) {
        if (self.passport != null && self.passport != "") {
          let passvali = self.passportvalidation(self.passport);
          passcondi = passvali;
        }
        else {
          passcondi = true;
          self.passport = null;
        }
      }
      else {
        passcondi = true;
        self.passport = "";
      }

      let taxvali = true;
      if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
        taxvali = true;
      }
      else {
        taxvali = self.taxvalidation(self.addpersonalinfo.taxpayerID);
      }

      let personalcondi = false;
      if (self.addpersonalinfo.personalID_Number == null || self.addpersonalinfo.personalID_Number == "") {
        personalcondi = true;
      }
      else {
        personalcondi = self.taxvalidation(self.addpersonalinfo.personalID_Number);
      }

      let taxcheck = false;
      if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
        taxcheck = false;
      }
      else {
        if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
          taxcheck = isNaN(self.addpersonalinfo.taxpayerID);
        }
        else {
          taxcheck = false;
        }
      }

      let personalcheck = false;
      if (self.addpersonalinfo.personalID_Number == null || self.addpersonalinfo.personalID_Number == "") {
        personalcheck = false;
      }
      else {
        if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
          personalcheck = isNaN(self.addpersonalinfo.personalID_Number);
        }
        else {
          personalcheck = false;
        }
      }

      let taxchecknull = true;
      if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
        if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
          if (self.addpersonalinfo.foreignemployee == false) {
            taxchecknull = false;
          }
          else {
            taxchecknull = true;
          }
        }
        else {
          taxchecknull = true;
        }
      }

      if (
        passcondi == true &&
        mobilevali == true &&
        personalcondi == true &&
        taxcheck == false &&
        personalcheck == false &&
        taxvali == true &&
        taxchecknull == true &&
        self.addpersonalinfo.employeecode != null &&
        self.addpersonalinfo.prefix != null &&
        self.addpersonalinfo.prefix != "" &&
        self.addpersonalinfo.firstname != null &&
        self.addpersonalinfo.lastname != null &&
        self.addpersonalinfo.firstname != "" &&
        self.addpersonalinfo.lastname != "" &&
        self.addpersonalinfo.gender != "" &&
        self.addpersonalinfo.religion != "" &&
        self.addpersonalinfo.DOB != "" &&
        self.addpersonalinfo.age != null &&
        self.addpersonalinfo.martialstatus != "" &&
        self.passport != null &&
        self.addpersonalinfo.foreignemployee != null &&
        self.addpersonalinfo.employeetype != null &&
        self.addpersonalinfo.hiredate != null &&
        (self.addpersonalinfo.employeestatus == "Probation" && (self.addpersonalinfo.probationperiod == null || self.addpersonalinfo.probationperiod == "")) ||
        self.addpersonalinfo.probationdate != "" &&
        self.addpersonalinfo.department != "" &&
        self.addpersonalinfo.division != "" &&
        self.addpersonalinfo.section != "" &&
        self.addpersonalinfo.position != "" &&
        self.addpersonalinfo.level != null &&
        self.addpersonalinfo.status != "" &&
        self.addpersonalinfo.status != null &&
        (self.addpersonalinfo.status !== 2 || self.addpersonalinfo.terminatedate) &&
        self.addpersonalinfo.housenumber != null &&
        self.addpersonalinfo.housenumber != "" &&
        self.addpersonalinfo.subdistrict != "" &&
        self.addpersonalinfo.district != "" &&
        self.addpersonalinfo.province != "" &&
        self.addpersonalinfo.country != "" &&
        self.addpersonalinfo.postalcode != "" &&
        self.addpersonalinfo.mobile_number != null &&
        self.addpersonalinfo.mobile_number != "" &&
        self.addpersonalinfo.email != null &&
        self.addpersonalinfo.email != ""
      ) {
        if (store.state.roleID == "Admin" && self.empCount < 1) {
          if (self.addpersonalinfo.ReportToEmployeeId === null) {
            self.addpersonalinfo.ReportToEmployeeId = 0;
            return true;
          }
          else {
            return false;
          }
        }
        else {
          if (self.addpersonalinfo.ReportToEmployeeId && self.addpersonalinfo.ReportToEmployeeId !== 0) {
            return true;
          }
          else {
            return false;
          }
        }
      }
      else {
        return false;
      }
    },

    //  validation of field and select when edit
    validateditpersonalinfo() {
      let self = this;
      let mobilevali = self.mobilenumbervalidation(self.addpersonalinfo.mobile_number);

      let passcondi = false;
      if (self.addpersonalinfo.foreignemployee == true) {
        if (self.passport != null && self.passport != "" && self.passport != "N/A") {
          let passvali = self.passportvalidation(self.passport);
          passcondi = passvali;
        }
        else {
          passcondi = true;
          self.passport = null;
        }
      }
      else {
        passcondi = true;
        self.passport = "";
      }

      let taxvalid = true;
      if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
        taxvalid = true;
      }
      else {
        taxvalid = self.taxvalidation(self.addpersonalinfo.taxpayerID);
      }

      let personalcondi = false;
      if (self.addpersonalinfo.personalID_Number == null || self.addpersonalinfo.personalID_Number == "") {
        personalcondi = true;
      }
      else {
        personalcondi = self.taxvalidation(self.addpersonalinfo.personalID_Number);
      }

      let taxcheck = false;
      if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
        taxcheck = false;
      }
      else {
        if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
          taxcheck = isNaN(self.addpersonalinfo.taxpayerID);
        }
        else {
          taxcheck = false;
        }
      }

      let personalcheck = false;
      if (self.addpersonalinfo.personalID_Number == null || self.addpersonalinfo.personalID_Number == "") {
        personalcheck = false;
      }
      else {
        if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
          personalcheck = isNaN(self.addpersonalinfo.personalID_Number);
        }
        else {
          personalcheck = false;
        }
      }

      let taxchecknull = true;
      if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
        if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
          if (self.addpersonalinfo.foreignemployee == false) {
            taxchecknull = false;
          }
          else {
            taxchecknull = true;
          }
        }
        else {
          taxchecknull = true;
        }
      }

      if (
        passcondi == true &&
        mobilevali == true &&
        personalcondi == true &&
        taxcheck == false &&
        personalcheck == false &&
        taxvalid == true &&
        taxchecknull == true &&
        self.passport != null &&
        self.addpersonalinfo.employeecode != null &&
        self.addpersonalinfo.employeecode != "" &&
        self.addpersonalinfo.prefix != null &&
        self.addpersonalinfo.prefix != "" &&
        self.addpersonalinfo.firstname != null &&
        self.addpersonalinfo.firstname != "" &&
        self.addpersonalinfo.lastname != null &&
        self.addpersonalinfo.lastname != "" &&
        self.addpersonalinfo.gender != "" &&
        self.addpersonalinfo.religion != "" &&
        self.addpersonalinfo.DOB != "" &&
        self.addpersonalinfo.age != null &&
        self.addpersonalinfo.martialstatus != "" &&
        self.addpersonalinfo.foreignemployee != null &&
        self.addpersonalinfo.employeetype != null &&
        self.addpersonalinfo.hiredate != null &&
        (self.addpersonalinfo.employeestatus == "Probation" && (self.addpersonalinfo.probationperiod == null || self.addpersonalinfo.probationperiod == "")) ||
        self.addpersonalinfo.probationdate != "" &&
        self.addpersonalinfo.department != "" &&
        self.addpersonalinfo.division != "" &&
        self.addpersonalinfo.section != "" &&
        self.addpersonalinfo.position != "" &&
        self.addpersonalinfo.level != null &&
        self.addpersonalinfo.status != "" &&
        self.addpersonalinfo.housenumber != null &&
        self.addpersonalinfo.housenumber != "" &&
        self.addpersonalinfo.subdistrict != "" &&
        self.addpersonalinfo.district != "" &&
        self.addpersonalinfo.province != "" &&
        self.addpersonalinfo.country != "" &&
        self.addpersonalinfo.postalcode != "" &&
        self.addpersonalinfo.mobile_number != null &&
        self.addpersonalinfo.mobile_number != "" &&
        self.addpersonalinfo.email != null &&
        self.addpersonalinfo.email != ""
      ) {
        if (store.state.roleID == "Admin" && self.empCount <= 1) {
          if (self.addpersonalinfo.ReportToEmployeeId === null || self.addpersonalinfo.ReportToEmployeeId === 0) {
            self.addpersonalinfo.ReportToEmployeeId = 0;
            return true;
          }
          else {
            return true;
          }
        }
        else {
          if (self.addpersonalinfo.ReportToEmployeeId && self.addpersonalinfo.ReportToEmployeeId !== 0) {
            return true;
          }
          else {
            return false;
          }
        }
      }
      else {
        return false;
      }
    },

    // showing errors for add
    validateerror() {
      let self = this;
      let passcondi = false;
      if (self.addpersonalinfo.foreignemployee == true) {
        if (self.passport != null && self.passport != "") {
          let passvali = self.passportvalidation(self.passport);
          passcondi = passvali;
        }
      }
      else {
        passcondi = true;
        self.passport = "";
      }

      let mobilevali = self.mobilenumbervalidation(self.addpersonalinfo.mobile_number);
      let taxvali = true;
      if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
        taxvali = true;
      }
      else {
        taxvali = self.taxvalidation(self.addpersonalinfo.taxpayerID);
      }

      let personalcondi = false;
      if (self.addpersonalinfo.personalID_Number == null || self.addpersonalinfo.personalID_Number == "") {
        personalcondi = true;
      } else {
        personalcondi = self.taxvalidation(self.addpersonalinfo.personalID_Number);
      }

      let taxcheck = false;
      if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
        taxcheck = false;
      }
      else {
        if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
          taxcheck = isNaN(self.addpersonalinfo.taxpayerID);
        }
        else {
          taxcheck = false;
        }
      }

      let personalcheck = false;
      if (self.addpersonalinfo.personalID_Number == null || self.addpersonalinfo.personalID_Number == "") {
        personalcheck = false;
      }
      else {
        if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
          personalcheck = isNaN(self.addpersonalinfo.personalID_Number);
        }
        else {
          personalcheck = false;
        }
      }

      let taxchecknull = true;
      if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
        if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
          if (self.addpersonalinfo.foreignemployee == false) {
            taxchecknull = false;
          }
          else {
            taxchecknull = true;
          }
        }
        else {
          taxchecknull = true;
        }
      }
      if (
        taxchecknull == false ||
        self.addpersonalinfo.employeecode == null ||
        self.addpersonalinfo.prefix == null ||
        self.addpersonalinfo.prefix == "" ||
        self.addpersonalinfo.firstname == null ||
        self.addpersonalinfo.lastname == null ||
        self.addpersonalinfo.gender == "" ||
        self.addpersonalinfo.religion == "" ||
        self.addpersonalinfo.DOB == "" ||
        self.addpersonalinfo.age == null ||
        self.addpersonalinfo.martialstatus == "" ||
        self.passport == null ||
        self.addpersonalinfo.foreignemployee == null ||
        self.addpersonalinfo.employeetype == null ||
        self.addpersonalinfo.hiredate == null ||
        (self.addpersonalinfo.employeestatus == "Probation" && (self.addpersonalinfo.probationperiod == null || self.addpersonalinfo.probationperiod == "")) ||
        self.addpersonalinfo.probationdate == "" ||
        self.addpersonalinfo.department == "" ||
        self.addpersonalinfo.division == "" ||
        self.addpersonalinfo.section == "" ||
        self.addpersonalinfo.position == "" ||
        self.addpersonalinfo.level == null ||
        self.addpersonalinfo.shiftcode == "" ||
        self.addpersonalinfo.status == null ||
        self.addpersonalinfo.housenumber == null ||
        self.addpersonalinfo.subdistrict == "" ||
        self.addpersonalinfo.district == "" ||
        self.addpersonalinfo.province == "" ||
        self.addpersonalinfo.country == "" ||
        self.addpersonalinfo.postalcode == "" ||
        self.addpersonalinfo.mobile_number == null ||
        self.addpersonalinfo.email == null
      ) {
        if (store.state.roleID != "Admin" && self.empCount < 1) {
          if (self.addpersonalinfo.ReportToEmployeeId == null) {
            alert("Please fill the required fields");
          }
        }
        else {
          alert("Please fill all the required fields");
        }
      }
      else if (mobilevali != true) {
        alert("Please fill in 9 - 11 digit number");
        this.error.errormessagemobile = this.addpersonalinfo.mobile_number != mobilevali ? "Please fill in 9 - 11 digit number" : self.addpersonalinfo.mobile;
      }
      else if (self.addpersonalinfo.ReportToEmployeeId == null) {
        alert("Please fill Report To field");
      }
      else if (self.imageUrl == undefined || self.imageUrl == null) {
        alert("Please fill Profile Image");
      }
      else if (taxvali != true && passcondi != true) {
        alert("Please fill correct format");
        this.error.errormessagetaxpayer = this.addpersonalinfo.taxpayerID != taxvali ? "Please fill 13 digits tax payer ID" : self.addpersonalinfo.taxpayerID;
        this.error.errormessagepassport = this.passport != passcondi ? "Please fill 6 to 9 characters" : self.addpersonalinfo.taxpayerID;
      }
      else if (taxcheck == true) {
        alert("Please fill digits only");
        this.error.errormessagetaxpayer = "Please fill digits only";
      }
      else if (personalcheck == true) {
        alert("Please fill digits only");
        this.error.errormessagepersonalid = "Please fill digits only";
      }
      else if (personalcondi != true) {
        alert("Please fill 13 digits Personal ID");
        this.error.errormessagepersonalid = this.addpersonalinfo.personalID_Number != personalcondi ? "Please fill 13 digits Personal ID" : self.addpersonalinfo.personalID_Number;
      }
      else if (taxvali != true) {
        alert("Please fill 13 digits tax payer ID");
        this.error.errormessagetaxpayer = this.addpersonalinfo.taxpayerID != taxvali ? "Please fill 13 digits tax payer ID" : self.addpersonalinfo.taxpayerID;
      }
      else if (passcondi != true) {
        alert("Please fill 6 to 9 characters");
        this.error.errormessagepassport = this.passport != passcondi ? "Please fill 6 to 9 characters" : self.addpersonalinfo.taxpayerID;
      }
    },

    // showing errors for edit
    validateediterror() {
      let self = this;
      let mobilevali = self.mobilenumbervalidation(self.addpersonalinfo.mobile_number);
      let passcondi = false;
      if (self.addpersonalinfo.foreignemployee == true) {
        if (self.passport != null && self.passport != "") {
          let passvali = self.passportvalidation(self.passport);
          passcondi = passvali;
        }
      }
      else {
        passcondi = true;
        self.passport = "";
      }

      let taxvali = true;
      if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
        taxvali = true;
      }
      else {
        taxvali = self.taxvalidation(self.addpersonalinfo.taxpayerID);
      }

      let personalcondi = false;
      if (self.addpersonalinfo.personalID_Number == null || self.addpersonalinfo.personalID_Number == "") {
        personalcondi = true;
      }
      else {
        personalcondi = self.taxvalidation(self.addpersonalinfo.personalID_Number);
      }

      let taxcheck = false;
      if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
        taxcheck = false;
      }
      else {
        if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
          taxcheck = isNaN(self.addpersonalinfo.taxpayerID);
        }
        else {
          taxcheck = false;
        }
      }

      let personalcheck = false;
      if (self.addpersonalinfo.personalID_Number == null || self.addpersonalinfo.personalID_Number == "") {
        personalcheck = false;
      }
      else {
        if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
          personalcheck = isNaN(self.addpersonalinfo.personalID_Number);
        }
        else {
          personalcheck = false;
        }
      }

      let taxchecknull = true;
      if (store.state.country == "Thailand" || store.state.country == "Thai" || store.state.country == "ไทย" || store.state.country == "ประเทศไทย") {
        if (self.addpersonalinfo.taxpayerID == null || self.addpersonalinfo.taxpayerID == "") {
          if (self.addpersonalinfo.foreignemployee == false) {
            taxchecknull = false;
          }
          else {
            taxchecknull = true;
          }
        }
        else {
          taxchecknull = true;
        }
      }
      if (
        taxchecknull == false ||
        self.addpersonalinfo.employeecode == null ||
        self.addpersonalinfo.employeecode == "" ||
        self.addpersonalinfo.prefix == null ||
        self.addpersonalinfo.prefix == "" ||
        self.addpersonalinfo.firstname == null ||
        self.addpersonalinfo.firstname == "" ||
        self.addpersonalinfo.lastname == null ||
        self.addpersonalinfo.lastname == "" ||
        self.addpersonalinfo.gender == "" ||
        self.addpersonalinfo.religion == "" ||
        self.addpersonalinfo.DOB == "" ||
        self.addpersonalinfo.age == null ||
        self.addpersonalinfo.martialstatus == "" ||
        self.passport == null ||
        self.addpersonalinfo.foreignemployee == null ||
        self.addpersonalinfo.employeetype == null ||
        self.addpersonalinfo.hiredate == null ||
        (self.addpersonalinfo.employeestatus == "Probation" && (self.addpersonalinfo.probationperiod == null || self.addpersonalinfo.probationperiod == "")) ||
        self.addpersonalinfo.probationdate == "" ||
        self.addpersonalinfo.department == "" ||
        self.addpersonalinfo.division == "" ||
        self.addpersonalinfo.section == "" ||
        self.addpersonalinfo.position == "" ||
        self.addpersonalinfo.level == null ||
        self.addpersonalinfo.status == "" ||
        self.addpersonalinfo.housenumber == null ||
        self.addpersonalinfo.housenumber == "" ||
        self.addpersonalinfo.subdistrict == "" ||
        self.addpersonalinfo.district == "" ||
        self.addpersonalinfo.province == "" ||
        self.addpersonalinfo.country == "" ||
        self.addpersonalinfo.postalcode == "" ||
        self.addpersonalinfo.mobile_number == null ||
        self.addpersonalinfo.mobile_number == "" ||
        self.addpersonalinfo.email == null ||
        self.addpersonalinfo.email == "" ||
        self.imageUrl == "" ||
        self.imageUrl == null
      ) {
        if (store.state.roleID != "Admin" && self.empCount < 1) {
          if (self.addpersonalinfo.ReportToEmployeeId == null) {
            alert("Please fill the required fields");
          }
        }
        else {
          alert("Please fill all the required fields");
        }
      }
      else if (mobilevali != true) {
        alert("Please fill in 9 - 11 digit number");
        this.error.errormessagemobile = this.addpersonalinfo.mobile_number != mobilevali ? "Please fill in 9 - 11 digit number" : self.addpersonalinfo.mobile;
      }
      else if (self.imageUrl == undefined || self.imageUrl == null) {
        alert("Please fill Profile Image");
      }
      else if (taxcheck == true) {
        alert("Please fill digits only");
        this.error.errormessagetaxpayer = "Please fill digits only";
      }
      else if (personalcheck == true) {
        alert("Please fill digits only");
        this.error.errormessagepersonalid = "Please fill digits only";
      }
      else if (personalcondi != true) {
        alert("Please fill 13 digits Personal ID");
        this.error.errormessagepersonalid = this.addpersonalinfo.personalID_Number != personalcondi ? "Please fill 13 digits Personal ID" : self.addpersonalinfo.personalID_Number;
      }
      else if (taxvali != true) {
        alert("Please fill 13 digits tax payer ID");
        this.error.errormessagetaxpayer = this.addpersonalinfo.taxpayerID != taxvali ? "Please fill 13 digits tax payer ID" : self.addpersonalinfo.taxpayerID;
      }
      else if (passcondi != true) {
        alert("Please fill 6 to 9 characters");
        this.error.errormessagepassport = this.passport != passcondi ? "Please fill 6 to 9 characters" : self.addpersonalinfo.taxpayerID;
      }
      else if (self.addpersonalinfo.ReportToEmployeeId == null || self.addpersonalinfo.ReportToEmployeeId == 0) {
        alert("Please fill Report To field");
      }
    },
  },
};
</script>

<style scoped>
::v-deep .hidden-input .mx-input-wrapper {
  display: none !important;
}
::v-deep .v-dialog {
  scrollbar-width: none!important;
}

::v-deep .datepicker-container .mx-datepicker {
  display: none !important;
}

::v-deep .personalcal .mx-datepicker-popup {
  top: 120% !important;
  left: 27% !important;
}

.custom-label-1 {
  font-size: 12px;
  margin-top: -5px;
}

>>>.vue-preview--fill {
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 50% !important;
  border: 1px solid white;
}

>>>.v-dialog::-webkit-scrollbar {
  width: 6px;
  background-color: none;
}

>>>.v-dialog::-webkit-scrollbar-thumb {
  background: #707070;
  outline: 1px solid #654321;
}

.v-application p {
  margin-bottom: 0 !important;
}

>>>.v-data-table>.v-data-table__wrapper>table {
  border: 1px solid #f99d20 !important;
}

@media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
  .btn_edit {
    margin-left: -1rem !important;
  }
}

.v-application--is-ltr .offset-md-10 {
  margin-left: unset;
}

>>>.v-select__selections {
  padding-left: unset !important;
}

>>>.theme--light.v-select .v-select__selection--comma {
  color: unset !important;
}

@media only screen and (max-width: 320px) {
  .department-btn {
    margin-left: -1rem !important;
  }

  .file-btn {
    margin-left: -5px !important;
  }
}

@media only screen and (max-width: 414px) {
  .save_btn {
    margin-top: 1rem !important;
  }

  .file-btn {
    margin-left: 5px;
  }
}

@media (max-width: 414px) {
  .fix-d {
    margin-top: 0rem !important;
  }

  .btn_fix {
    width: 100px !important;
    margin-right: 1rem !important;
  }
}

.labInfo {
  color: #f99d20;
  font-size: 15px;
  margin-left: -770px;
}

.empID {
  margin: 0px;
  padding: 0px;
  font-size: 19px;
  font-family: "Kanit", sans-serif;
  /* color: yellow; */
}

.content {
  padding-top: 0;
  margin-top: -1.5rem;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: rgba(0, 0, 0, 0.87);
}

>>>.v-input .v-label {
  font-size: 17px;
}

>>>.theme--light.v-input input {
  font-size: 17px;
}

>>>.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__slot>input {
  font-size: 16px;
}

>>>.theme--light.v-input:not(.v-input--is-disabled) input,
.theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: #8d8e8a;
}

>>>.theme--light.v-select .v-select__selections {
  color: #8a8c8e;
}

/* .v-select__selections {
    padding-left: 1.5rem;
    font-size: 18px;
} */
.button {
  height: 40px;
  display: inline-block;
  padding: 9px 15px;
  background-color: #f99d20;
  color: white;
  border: 0;
  line-height: inherit;
  text-decoration: none;
  cursor: pointer;
}

.input {
  display: inline-block;
  height: 40px;
  width: 420px;
  margin-bottom: 0px;
  padding: 9px 12px;
  color: #f99d20;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #f99d20;
  margin: 0;
  line-height: 1.42857143;
}

.forlabel {
  font-size: 15px;
  color: #8a8c8e;
}

.fortext {
  font-size: 15px;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
}

.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
  padding: 0 !important;
}

@media only screen and (min-width: 2490px) and (max-width: 2560px) {
  .rp {
    margin-left: -23rem !important;
  }
}

@media only screen and (min-width: 1900px) and (max-width: 2485px) {
  .rp {
    margin-left: -17rem !important;
  }
}

@media only screen and (min-width: 1600px) and (max-width: 1899px) {
  .rp {
    margin-left: -10rem !important;
  }
}

@media only screen and (min-width: 1300px) and (max-width: 1599px) {
  .rp {
    margin-left: -6.5rem !important;
  }
}

@media only screen and (min-width: 1264px) and (max-width: 1299px) {
  .rp {
    margin-left: -4rem !important;
  }

  ::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: rgba(0, 0, 0, 0.87);
    max-width: 190px !important;
  }
}

@media only screen and (min-width: 960px) and (max-width: 1260px) {
  .edu {
    margin-left: 7rem !important;
  }

  .per {
    width: 7.5rem !important;
  }

  .perfile {
    width: 3rem !important;
  }

  .addpic {
    width: 9rem !important;
  }

  ::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: rgba(0, 0, 0, 0.87);
    max-width: 150px !important;
  }
}

@media (width: 1280px) {
  .fix-btn {
    margin-left: -1rem !important;
  }

  .file-btn {
    margin-left: -5px;
  }
}

@media (width: 768px) {
  .fix-txt {
    margin-left: 0.2rem !important;
  }

  .file-btn {
    margin-left: -7px;
  }
}

.btnsize {
  width: 120px;
}

@media (width: 320px) {
  .btnsize {
    width: 80px !important;
  }
}

*>>>.forage>.v-input__control>.v-input__slot {
  border-color: rgba(0, 0, 0, 0.42) !important;
  border-style: solid !important;
  border-width: 0 0 thin 0 !important;
}

.date-picker-container {
  position: relative;
  margin-top: 1rem;
  width: 100%;
}

.date-picker-label {
  position: absolute;
  top: -1rem;
  left: 0;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.54);
}
</style>